
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3f3a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3f3a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $acaa33316dab9fc8$exports = {};
$parcel$extendImportMap({
    "f6ezO": "sw.js",
    "gU4WN": "logo.f07b9655.png"
});

// ============================================================
//  MASAMADREAM — App Entry Point
//  Fase 5: onboarding, moods, web share, abandon process
// ============================================================
// ============================================================
//  MASAMADREAM — Store (LocalStorage)
//  Gestión de estado persistente
// ============================================================
const $3fa2584d11fbd999$var$STORAGE_KEY = 'masagotchi_state';
const $3fa2584d11fbd999$var$DEFAULT_STATE = {
    processes: [],
    viewingId: null,
    history: [],
    starterName: '',
    achievements: []
};
class $3fa2584d11fbd999$export$390f32400eaf98c9 {
    constructor(){
        this._state = this._read();
    }
    // ── Hydrate from localStorage ─────────────────────────────
    _read() {
        try {
            const raw = localStorage.getItem($3fa2584d11fbd999$var$STORAGE_KEY);
            if (!raw) return structuredClone($3fa2584d11fbd999$var$DEFAULT_STATE);
            const parsed = JSON.parse(raw);
            return {
                ...$3fa2584d11fbd999$var$DEFAULT_STATE,
                ...parsed
            };
        } catch  {
            return structuredClone($3fa2584d11fbd999$var$DEFAULT_STATE);
        }
    }
    // ── Persist to localStorage ───────────────────────────────
    _write() {
        try {
            localStorage.setItem($3fa2584d11fbd999$var$STORAGE_KEY, JSON.stringify(this._state));
        } catch (e) {
            console.warn('[MM] Storage write failed:', e);
        }
    }
    // ── Public API ────────────────────────────────────────────
    load() {
        this._state = this._read();
        // Migration: backward-compat - if old activeProcess exists, migrate to processes[]
        if (this._state.activeProcess && !this._state.processes) {
            const old = this._state.activeProcess;
            const label = old.type === 'p1' ? "Fermentaci\xf3n #1" : "Preparaci\xf3n #1";
            this._state.processes = [
                {
                    id: 'proc_' + Date.now(),
                    type: old.type,
                    label: label,
                    startDate: old.startDate,
                    currentDay: this._calcCurrentDay(old.startDate, old.type),
                    completedIds: old.completedIds || [],
                    rating: old.rating || null
                }
            ];
            this._state.viewingId = this._state.processes[0].id;
            delete this._state.activeProcess;
            this._write();
        }
        // Recalculate currentDay from startDate for ALL active processes
        if (this._state.processes && this._state.processes.length) this._state.processes.forEach((p)=>{
            p.currentDay = this._calcCurrentDay(p.startDate, p.type);
        });
        return this._state;
    }
    get state() {
        return this._state;
    }
    getProcess(id) {
        return this._state.processes?.find((p)=>p.id === id) || null;
    }
    getViewingProcess() {
        if (!this._state.viewingId) return null;
        return this.getProcess(this._state.viewingId);
    }
    setViewingId(id) {
        this._state.viewingId = id;
        this._write();
    }
    getActiveProcesses() {
        return this._state.processes || [];
    }
    startProcess(type) {
        const processes = this._state.processes || [];
        // Count existing processes of this type for auto-numbering
        const count = processes.filter((p)=>p.type === type).length + 1;
        const typeLabels = {
            p1: "Fermentaci\xf3n",
            p2: "Preparaci\xf3n",
            p3: 'Pizza'
        };
        const label = `${typeLabels[type] ?? type.toUpperCase()} #${count}`;
        const process = {
            id: 'proc_' + Date.now() + '_' + Math.random().toString(36).slice(2, 7),
            type: type,
            label: label,
            startDate: new Date().toISOString(),
            currentDay: 1,
            completedIds: [],
            rating: null
        };
        this._state.processes = processes;
        this._state.processes.push(process);
        this._state.viewingId = process.id;
        this._write();
        return process;
    }
    // Mark an activity as completed
    completeActivity(activityId, processId = this._state.viewingId) {
        const process = this.getProcess(processId);
        if (!process) return;
        const ids = process.completedIds;
        if (!ids.includes(activityId)) {
            ids.push(activityId);
            this._write();
        }
    }
    uncompleteActivity(activityId, processId = this._state.viewingId) {
        const process = this.getProcess(processId);
        if (!process) return;
        const ids = process.completedIds;
        const idx = ids.indexOf(activityId);
        if (idx !== -1) {
            ids.splice(idx, 1);
            this._write();
        }
    }
    isCompleted(activityId, processId = this._state.viewingId) {
        const process = this.getProcess(processId);
        return process?.completedIds?.includes(activityId) ?? false;
    }
    // Archive the current process
    archiveProcess(processId, outcome = 'completed', rating = null) {
        const process = this.getProcess(processId);
        if (!process) return;
        const archived = {
            ...process,
            endDate: new Date().toISOString(),
            outcome: outcome,
            rating: rating
        };
        this._state.history.push(archived);
        this._state.processes = this._state.processes.filter((p)=>p.id !== processId);
        if (this._state.viewingId === processId) this._state.viewingId = this._state.processes[0]?.id || null;
        this._write();
    }
    // ── Starter name (Fase 6) ────────────────────────────────
    setStarterName(name) {
        this._state.starterName = (name || '').trim().slice(0, 30);
        this._write();
    }
    getStarterName() {
        return this._state.starterName || '';
    }
    // ── Achievements (Fase 6) ─────────────────────────────────
    /**
   * Unlock an achievement by id.
   * Returns true if it was newly unlocked, false if already had it.
   */ unlockAchievement(id) {
        if (!Array.isArray(this._state.achievements)) this._state.achievements = [];
        if (this._state.achievements.includes(id)) return false;
        this._state.achievements.push(id);
        this._write();
        return true;
    }
    getAchievements() {
        return Array.isArray(this._state.achievements) ? [
            ...this._state.achievements
        ] : [];
    }
    // ── Edit start date (reset cycle timeline) ───────────────
    /**
   * Override the start date of the active process.
   * @param {string} isoString — e.g. new Date(localDt).toISOString()
   * Returns the updated process or null if no active process.
   */ setStartDate(isoString, processId) {
        const process = this.getProcess(processId);
        if (!process) return null;
        process.startDate = isoString;
        process.currentDay = this._calcCurrentDay(isoString, process.type);
        this._write();
        return process;
    }
    // ── Clear all data (Fase 6) ───────────────────────────────
    clearAll() {
        this._state = structuredClone($3fa2584d11fbd999$var$DEFAULT_STATE);
        try {
            localStorage.removeItem($3fa2584d11fbd999$var$STORAGE_KEY);
            // Also clear onboarding flag so it shows again
            localStorage.removeItem('mm_onboarded');
        } catch (_) {}
    }
    // ── Helpers ───────────────────────────────────────────────
    _calcCurrentDay(startDateISO, type) {
        const maxDaysMap = {
            p1: 7,
            p2: 5,
            p3: 2
        };
        const maxDays = maxDaysMap[type] ?? 7;
        const start = new Date(startDateISO);
        const now = new Date();
        const diffMs = now - start;
        const diffDays = Math.floor(diffMs / 86400000) + 1;
        return Math.min(Math.max(diffDays, 1), maxDays);
    }
    // Ms until next activity (based on timeOffset from startDate)
    msUntilNextActivity(activities) {
        const process = this.getViewingProcess();
        if (!process) return null;
        const start = new Date(process.startDate);
        const completedIds = process.completedIds;
        const now = Date.now();
        // Find the earliest incomplete activity whose scheduled time is in the future
        const pending = activities.filter((a)=>!completedIds.includes(a.id)).map((a)=>({
                ...a,
                scheduledAt: start.getTime() + a.timeOffset * 3600000
            })).sort((a, b)=>a.scheduledAt - b.scheduledAt);
        // Past-due but incomplete: show 0
        const overdue = pending.find((a)=>a.scheduledAt <= now);
        if (overdue) return 0;
        // Next future activity
        const next = pending.find((a)=>a.scheduledAt > now);
        return next ? next.scheduledAt - now : null;
    }
}


// ============================================================
//  MASAMADREAM — Process Data
//  Fuente de verdad: actividades P1 y P2
// ============================================================
// Cada actividad: { id, day, time, action, description, duration }
// time: offset en HORAS desde el inicio del proceso
const $deb185f198c84388$export$ffa50ca9b2a96ffa = {
    // ── P1: Fermentación desde Cero (7 días) ─────────────────
    p1: {
        label: "Fermentaci\xf3n",
        emoji: "\uD83C\uDF31",
        totalDays: 7,
        activities: [
            {
                id: 'p1-d1-a1',
                day: 1,
                timeOffset: 0,
                action: 'Mezcla Inicial',
                description: 'Mezcla 50 g de harina y 50 ml de agua en un frasco.',
                duration: '10 min',
                emoji: "\uD83E\uDD63",
                instructions: [
                    "Lava bien el frasco de vidrio con agua caliente \u2014 sin jab\xf3n para no matar las levaduras.",
                    "Pesa 50 g de harina de trigo integral o de centeno (preferiblemente org\xe1nica).",
                    'Pesa 50 ml de agua sin cloro: usa agua filtrada o deja reposar el agua del grifo 30 min.',
                    'Vierte el agua en el frasco primero, luego la harina.',
                    'Mezcla vigorosamente con una cuchara limpia hasta que no queden grumos secos.',
                    'Marca el nivel de la mezcla con una liga o un marcador en el vidrio.',
                    "Cubre con un pa\xf1o limpio o una tapa suelta \u2014 nunca herm\xe9tico, necesita respirar.",
                    "Deja reposar a temperatura ambiente (ideal 21\u201324 \xb0C). \xa1El proceso ha comenzado!"
                ]
            },
            {
                id: 'p1-d2-a1',
                day: 2,
                timeOffset: 24,
                action: 'Alimentar',
                description: "A\xf1ade 50 g de harina y 50 ml de agua. Descarta la mitad.",
                duration: '5 min',
                emoji: "\uD83C\uDF3E",
                instructions: [
                    "Observa la mezcla: puede haber peque\xf1as burbujas o un ligero olor \xe1cido \u2014 \xa1es normal!",
                    'Con una cuchara, retira y descarta la mitad de la mezcla (aprox. 50 g).',
                    "Pesa 50 g de harina fresca (puedes mezclar 50% trigo / 50% centeno para m\xe1s actividad).",
                    'Pesa 50 ml de agua sin cloro a temperatura ambiente.',
                    "A\xf1ade el agua primero, luego la harina, y mezcla bien.",
                    'Actualiza la marca de nivel en el frasco.',
                    'Devuelve al mismo lugar a temperatura ambiente.',
                    "\uD83D\uDCA1 Tip: el descarte se puede usar para hacer panqueques o crackers."
                ]
            },
            {
                id: 'p1-d3-a1',
                day: 3,
                timeOffset: 48,
                action: 'Alimentar',
                description: 'Repite el procedimiento (50 g harina, 50 ml agua).',
                duration: '5 min',
                emoji: "\uD83C\uDF3E",
                instructions: [
                    "Para el D\xeda 3 ya deber\xedas ver m\xe1s burbujas y un olor m\xe1s pronunciado \u2014 \xa1va bien!",
                    'Descarta la mitad de la mezcla antes de alimentar.',
                    'Agrega 50 g de harina y 50 ml de agua sin cloro.',
                    'Mezcla bien hasta integrar completamente.',
                    'Marca el nuevo nivel.',
                    "\uD83D\uDCA1 Si ves que dobl\xf3 su volumen desde la alimentaci\xf3n anterior, \xa1tus levaduras est\xe1n activas!",
                    "Mant\xe9n a temperatura constante. Evita cambios bruscos de temperatura."
                ]
            },
            {
                id: 'p1-d4-a1',
                day: 4,
                timeOffset: 72,
                action: 'Alimentar',
                description: "Contin\xfaa alimentando la mezcla (50 g harina, 50 ml agua).",
                duration: '5 min',
                emoji: "\uD83C\uDF3E",
                instructions: [
                    "El olor deber\xeda ser m\xe1s \xe1cido y agradable, como yogur o vinagre suave.",
                    'Descarta la mitad antes de alimentar.',
                    "A\xf1ade 50 g de harina y 50 ml de agua.",
                    'Mezcla bien y marca el nivel.',
                    '\uD83D\uDCA1 Si el cultivo parece "lento", prueba a mantenerlo en un lugar m\xe1s c\xe1lido (25\u201327 \xb0C).',
                    'Puedes empezar a ver una capa l\xedquida gris\xe1cea arriba \u2014 es "hooch", se\xf1al de hambre. \xa1Normal!'
                ]
            },
            {
                id: 'p1-d5-a1',
                day: 5,
                timeOffset: 96,
                action: 'Alimentar',
                description: 'Repite el procedimiento (50 g harina, 50 ml agua).',
                duration: '5 min',
                emoji: "\uD83C\uDF3E",
                instructions: [
                    "A estas alturas el cultivo deber\xeda tener una actividad visible: burbujas, crecimiento, buen olor.",
                    'Descarta la mitad antes de alimentar.',
                    "A\xf1ade 50 g de harina y 50 ml de agua. Mezcla bien.",
                    "Marca el nivel y observa cu\xe1nto crece en las pr\xf3ximas horas.",
                    "\uD83D\uDCA1 Prueba de flotaci\xf3n: coloca una cucharita en agua. Si flota, \xa1casi lista!",
                    "Si no flota todav\xeda, no te preocupes \u2014 sigue el proceso 1\u20132 d\xedas m\xe1s."
                ]
            },
            {
                id: 'p1-d6-a1',
                day: 6,
                timeOffset: 120,
                action: 'Alimentar',
                description: "Realiza la misma alimentaci\xf3n (50 g harina, 50 ml agua).",
                duration: '5 min',
                emoji: "\uD83C\uDF3E",
                instructions: [
                    "El cultivo deber\xeda estar muy activo ahora: dobla su volumen, burbujea, huele bien.",
                    'Descarta la mitad y alimenta con 50 g harina + 50 ml agua.',
                    'Mezcla bien y marca el nivel.',
                    "\uD83D\uDCA1 Ideal para usar: 4\u20138 horas despu\xe9s de alimentar, cuando est\xe1 en su pico de actividad.",
                    'El "pico" es cuando est\xe1 m\xe1s alto antes de empezar a bajar \u2014 ese es el momento perfecto.'
                ]
            },
            {
                id: 'p1-d7-a1',
                day: 7,
                timeOffset: 144,
                action: 'Alimentar y Verificar',
                description: "Alimenta y verifica si tu masa madre est\xe1 lista para usar.",
                duration: '10 min',
                emoji: "\uD83E\uDDEA",
                instructions: [
                    "Realiza la alimentaci\xf3n normal: descarta la mitad, a\xf1ade 50 g harina + 50 ml agua.",
                    "Espera 4\u20136 horas y realiza la prueba de flotaci\xf3n: \xbfflota una cucharita en agua? \u2705",
                    "Comprueba que haya doblado (o m\xe1s) su volumen desde la alimentaci\xf3n.",
                    "El olor debe ser agradablemente \xe1cido, a levadura o queso joven.",
                    "La textura al mezclar debe ser el\xe1stica y llena de burbujas.",
                    "\xa1Si pasa todas las pruebas, tu masa madre EST\xc1 LISTA para hacer pan! \uD83C\uDF5E",
                    "\uD83D\uDCA1 Para mantenerla: refrigera y alimenta 1 vez por semana. \xa1Puede vivir a\xf1os!"
                ]
            }
        ]
    },
    // ── P2: Preparación del Pan (5 etapas) ────────────────────
    p2: {
        label: "Preparaci\xf3n",
        emoji: "\uD83C\uDF5E",
        totalDays: 5,
        activities: [
            {
                id: 'p2-d1-a1',
                day: 1,
                timeOffset: 0,
                action: 'Pesar Ingredientes',
                description: 'Pesar todos los ingredientes necesarios para la receta.',
                duration: '10 min',
                emoji: "\u2696\uFE0F",
                instructions: [
                    'Receta base para 1 hogaza (850 g aprox):',
                    "\u2022 450 g de harina de trigo (preferiblemente de fuerza, W200+)",
                    "\u2022 320 ml de agua sin cloro (hidrataci\xf3n ~71%)",
                    "\u2022 100 g de masa madre activa (en su pico)",
                    "\u2022 9 g de sal marina fina",
                    "Usa una balanza de precisi\xf3n \u2014 en panader\xeda los gramos importan.",
                    "\uD83D\uDCA1 Aseg\xfarate de que tu masa madre est\xe9 activa: alimentala 4\u20138 horas antes."
                ]
            },
            {
                id: 'p2-d1-a2',
                day: 1,
                timeOffset: 0.17,
                action: 'Mezcla Inicial',
                description: "Mezclar agua con la masa madre en un taz\xf3n grande.",
                duration: '5 min',
                emoji: "\uD83E\uDED9",
                instructions: [
                    "En un taz\xf3n grande, vierte el agua a temperatura ambiente (24\u201326 \xb0C).",
                    "A\xf1ade la masa madre activa al agua.",
                    "Mezcla con los dedos o una esp\xe1tula hasta disolver la masa madre.",
                    "\uD83D\uDCA1 El agua tibia activa la fermentaci\xf3n m\xe1s r\xe1pido. Evita agua caliente.",
                    "La mezcla debe quedar lechosa y uniforme antes de a\xf1adir la harina."
                ]
            },
            {
                id: 'p2-d1-a3',
                day: 1,
                timeOffset: 0.25,
                action: 'Agregar Harina y Sal',
                description: 'Integrar la harina y la sal hasta obtener una pasta pegajosa.',
                duration: '5 min',
                emoji: "\uD83E\uDDC2",
                instructions: [
                    "A\xf1ade toda la harina a la mezcla de agua y masa madre.",
                    "Mezcla con las manos o una esp\xe1tula hasta que no queden partes secas.",
                    "La masa quedar\xe1 pegajosa y rugosa \u2014 es completamente normal.",
                    'Agrega la sal encima de la masa y pellizca con los dedos para integrarla.',
                    "\uD83D\uDCA1 No amasas todav\xeda \u2014 solo integrar. El gluten se desarrolla en el reposo.",
                    "Cubre el taz\xf3n con film pl\xe1stico o un gorro de ducha reutilizable."
                ]
            },
            {
                id: 'p2-d1-a4',
                day: 1,
                timeOffset: 0.5,
                action: 'Reposo Inicial',
                description: "Cubrir y dejar reposar 1 hora (aut\xf3lisis).",
                duration: '1 hora',
                emoji: "\uD83D\uDCA4",
                instructions: [
                    'Este proceso se llama "aut\xf3lisis" \u2014 la harina absorbe el agua y el gluten comienza a formarse solo.',
                    "Cubre el taz\xf3n y d\xe9jalo reposar 1 hora a temperatura ambiente.",
                    'NO manipules la masa durante este tiempo.',
                    "\uD83D\uDCA1 Despu\xe9s de la aut\xf3lisis ver\xe1s que la masa cambi\xf3: m\xe1s suave, m\xe1s extensible y menos pegajosa.",
                    "Este paso hace que el amasado posterior sea mucho m\xe1s f\xe1cil."
                ]
            },
            {
                id: 'p2-d2-a1',
                day: 2,
                timeOffset: 24,
                action: 'Pliegues',
                description: '4 series de pliegues con las manos mojadas, cada hora por 4 horas.',
                duration: "5 min c/hora \xd7 4",
                emoji: "\uD83E\uDD32",
                instructions: [
                    "M\xf3jate las manos para evitar que la masa se pegue.",
                    "Toma un extremo de la masa, est\xedralo hacia arriba y d\xf3blalo al centro.",
                    "Gira el taz\xf3n 90\xb0 y repite. Haz esto 4 veces por cada serie (Norte-Sur-Este-Oeste).",
                    "Notar\xe1s que la masa se vuelve m\xe1s tensa y el\xe1stica con cada serie.",
                    "\u23F1\uFE0F Repite este proceso 4 veces, dejando 1 hora de reposo entre cada serie.",
                    "\uD83D\uDCA1 El objetivo es desarrollar fuerza y estructura en la masa sin calentarla.",
                    "Despu\xe9s de la \xfaltima serie, deja reposar sin tocar hasta la formaci\xf3n (D\xeda 3)."
                ]
            },
            {
                id: 'p2-d3-a1',
                day: 3,
                timeOffset: 28,
                action: "Formaci\xf3n de Hogazas",
                description: 'Preformar, reposar 20 min, formar y refrigerar en banetton.',
                duration: "15 min + refrigeraci\xf3n",
                emoji: "\uD83E\uDED3",
                instructions: [
                    'Enharina ligeramente la superficie de trabajo.',
                    "Vuelca la masa con cuidado y deja reposar 15\u201320 min destapada (bench rest).",
                    "Preforma: d\xf3blala sobre s\xed misma suavemente para crear tensi\xf3n superficial.",
                    "Despu\xe9s de 20 min, forma la hogaza final: dobla los lados hacia el centro, enrolla y sella.",
                    "Enharina bien el banetton (o un bol forrado con pa\xf1o enharinado).",
                    'Coloca la hogaza con la costura hacia arriba en el banetton.',
                    "Cubre con film pl\xe1stico y lleva al refrigerador (4\u20136 \xb0C).",
                    "\uD83D\uDCA1 La fermentaci\xf3n fr\xeda desarrolla m\xe1s sabor. Puede estar 24\u201348 horas en la nevera."
                ]
            },
            {
                id: 'p2-d4-a1',
                day: 4,
                timeOffset: 72,
                action: 'Sacar y Reposar',
                description: "Sacar del refrigerador y dejar reposar 1\u20132 horas.",
                duration: "1\u20132 horas",
                emoji: "\u23F1\uFE0F",
                instructions: [
                    "Saca el banetton del refrigerador con cuidado \u2014 no golpees la hogaza.",
                    "D\xe9jala reposar a temperatura ambiente 1\u20132 horas sin destapar.",
                    'Mientras, enciende el horno (siguiente actividad).',
                    "\uD83D\uDCA1 El reposo permite que la masa se atempere y est\xe9 lista para el horno.",
                    "Sabr\xe1s que est\xe1 lista cuando al presionar suavemente con el dedo, regresa lentamente."
                ]
            },
            {
                id: 'p2-d4-a2',
                day: 4,
                timeOffset: 74,
                action: 'Precalentar Horno',
                description: "Precalentar el horno y la olla de hierro a 500\xb0F / 260\xb0C por 20 min.",
                duration: '20 min',
                emoji: "\uD83D\uDD25",
                instructions: [
                    'Coloca la olla de hierro fundido (Dutch oven) dentro del horno con la tapa.',
                    "Enciende el horno a m\xe1xima temperatura: 500\xb0F (260\xb0C) o lo m\xe1s alto posible.",
                    "Precalienta por al menos 20 minutos \u2014 la olla debe estar MUY caliente.",
                    "\uD83D\uDCA1 La olla caliente crea vapor al sellarla, lo que produce una corteza crujiente.",
                    'Si no tienes olla de hierro, usa una bandeja profunda con tapa o papel aluminio.',
                    "Ten a mano: papel pergamino, una navaja o cuchillo muy afilado para gre\xf1ar."
                ]
            },
            {
                id: 'p2-d5-a1',
                day: 5,
                timeOffset: 96,
                action: 'Hornear Tapado',
                description: "Hornear 25 min a 500\xb0F tapado con vapor.",
                duration: '25 min',
                emoji: "\uD83C\uDF73",
                instructions: [
                    "Corta un trozo de papel pergamino del tama\xf1o del fondo de la olla.",
                    'Vuelca la hogaza sobre el papel pergamino (costura abajo, parte lisa arriba).',
                    "Con una navaja o cuchillo muy afilado, haz un corte diagonal de 1\u20132 cm de profundidad.",
                    "Con mucho cuidado saca la olla del horno (\xa1usa guantes gruesos!).",
                    "Levanta la hogaza con el papel y col\xf3cala dentro de la olla.",
                    "Tapa la olla y hornea por 25 minutos a 500\xb0F.",
                    "\uD83D\uDCA1 El vapor atrapado dentro es lo que permite que el pan se expanda correctamente.",
                    'No abras la tapa durante estos 25 minutos.'
                ]
            },
            {
                id: 'p2-d5-a2',
                day: 5,
                timeOffset: 96.42,
                action: 'Hornear Destapado',
                description: "Quitar la tapa y hornear a 450\xb0F por 20 min para la corteza.",
                duration: '20 min',
                emoji: "\uD83E\uDD50",
                instructions: [
                    "Con cuidado, retira la tapa de la olla (\xa1guantes!).",
                    "Baja la temperatura a 450\xb0F (230\xb0C).",
                    "Hornea sin tapa por 20 minutos m\xe1s.",
                    "Observa el color: debe quedar marr\xf3n oscuro \u2014 no tengas miedo del color.",
                    '\uD83D\uDCA1 Una corteza m\xe1s oscura = m\xe1s sabor y mejor textura. El pan "crudo" es color caramelo oscuro.',
                    "El pan est\xe1 listo cuando suena hueco al golpear el fondo."
                ]
            },
            {
                id: 'p2-d5-a3',
                day: 5,
                timeOffset: 96.75,
                action: 'Reposo Final',
                description: 'Sacar del horno y reposar al menos 30 min antes de cortar.',
                duration: '30+ min',
                emoji: "\uD83C\uDF89",
                instructions: [
                    "Saca el pan de la olla y col\xf3calo sobre una rejilla.",
                    "Escuchar\xe1s crepitar la corteza \u2014 \xa1eso es la magia del pan de masa madre!",
                    "Espera M\xcdNIMO 30 minutos antes de cortar. 1 hora es lo ideal.",
                    "\uD83D\uDCA1 El pan sigue cocin\xe1ndose internamente con el calor residual despu\xe9s de salir del horno.",
                    "Si cortas demasiado pronto, el interior quedar\xe1 gomoso.",
                    "\xa1Disfruta tu pan artesanal de masa madre! \uD83C\uDF5E\u2728"
                ]
            }
        ]
    },
    // ── P3: Pan de Pizza con Masa Madre ──────────────────────
    p3: {
        label: 'Pizza',
        emoji: "\uD83C\uDF55",
        totalDays: 2,
        activities: [
            {
                id: 'p3-d1-a1',
                day: 1,
                timeOffset: 0,
                action: "Aut\xf3lisis",
                description: 'Mezcla harina y agua hasta integrar, tapa 20 min.',
                duration: '20 min',
                emoji: "\uD83E\uDD63",
                instructions: [
                    "Ingredientes para 2 pizzas (28\u201330 cm):",
                    "\u2022 400 g de harina de fuerza (panadera, W260+)",
                    "\u2022 250 ml de agua tibia",
                    "\u2022 150 g de masa madre activa (100% hidrataci\xf3n)",
                    "\u2022 8 g de sal",
                    "\u2022 15 ml de aceite de oliva (opcional \u2014 da suavidad)",
                    'En un bol grande, vierte el agua tibia primero.',
                    "A\xf1ade la harina y mezcla con las manos o esp\xe1tula hasta que no queden restos secos.",
                    "Tapa el bol con film o un pa\xf1o h\xfamedo y deja reposar 20 minutos.",
                    "\uD83D\uDCA1 Este reposo (aut\xf3lisis) permite que el gluten se forme solo \u2014 la masa ser\xe1 m\xe1s extensible."
                ]
            },
            {
                id: 'p3-d1-a2',
                day: 1,
                timeOffset: 0.33,
                action: "A\xf1adir Masa Madre y Amasar",
                description: "Incorpora masa madre, sal y aceite. Amasa 5\u20137 min.",
                duration: '10 min',
                emoji: "\uD83E\uDD32",
                instructions: [
                    'Agrega los 150 g de masa madre activa sobre la mezcla reposada.',
                    "A\xf1ade los 8 g de sal (y el aceite de oliva si lo usas).",
                    "Amasa durante 5\u20137 minutos hasta obtener una masa lisa y el\xe1stica.",
                    "La masa puede estar ligeramente pegajosa \u2014 es normal a esta hidrataci\xf3n.",
                    "Prueba de ventana: estira un trozo fino entre los dedos. Si se transparenta sin romperse, est\xe1 lista.",
                    "\uD83D\uDCA1 Si se rompe enseguida, amasa 2 minutos m\xe1s y vuelve a probar.",
                    'Forma una bola y coloca en un bol ligeramente aceitado.'
                ]
            },
            {
                id: 'p3-d1-a3',
                day: 1,
                timeOffset: 0.5,
                action: "Fermentaci\xf3n en Fr\xedo",
                description: "Tapa y lleva a la nevera 12\u201316 h para m\xe1s sabor.",
                duration: "12\u201316 horas",
                emoji: "\uD83E\uDDCA",
                instructions: [
                    "Cubre el bol herm\xe9ticamente con film pl\xe1stico.",
                    "Introduce en la nevera (4\u20136 \xb0C).",
                    "La fermentaci\xf3n lenta en fr\xedo desarrolla m\xe1s sabor y hace la masa m\xe1s digestible.",
                    "\uD83D\uDCA1 Alternativa r\xe1pida: si tienes prisa, deja a temperatura ambiente (22\u201324 \xb0C) 3\u20134 horas haciendo pliegues cada 45 min.",
                    "Para la opci\xf3n en fr\xedo, la masa puede estar entre 12 y 16 horas \u2014 \xa1no pasa nada si son 18!",
                    "Ma\xf1ana retomas desde aqu\xed. \xa1Buenas noches, panadero! \uD83C\uDF19"
                ]
            },
            {
                id: 'p3-d2-a1',
                day: 2,
                timeOffset: 13,
                action: 'Dividir y Formar Bolas',
                description: "Saca de nevera, divide en 2 y deja reposar 20\u201330 min.",
                duration: '30 min',
                emoji: "\u2696\uFE0F",
                instructions: [
                    'Saca el bol de la nevera y deja atemperar 15 minutos.',
                    'Vuelca la masa sobre una superficie ligeramente enharinada.',
                    "Con un cuchillo o rasqueta, divide en 2 porciones iguales (\u2248 400 g cada una).",
                    "Forma una bola tensa con cada porci\xf3n: dobla los bordes hacia el centro y s\xe9llala.",
                    "Coloca las bolas con la costura hacia abajo, separadas, tapadas con un pa\xf1o.",
                    "Deja reposar 20\u201330 minutos a temperatura ambiente.",
                    "\uD83D\uDCA1 Este reposo relaja el gluten \u2014 si estiras sin reposar, la masa se encoge como un el\xe1stico.",
                    "No uses demasiada harina o perder\xe1s las burbujas de CO\u2082 que dan textura al borde."
                ]
            },
            {
                id: 'p3-d2-a2',
                day: 2,
                timeOffset: 13.5,
                action: 'Precalentar Horno',
                description: "Precalienta horno al m\xe1ximo con piedra o bandeja adentro, 45 min.",
                duration: '45 min',
                emoji: "\uD83D\uDD25",
                instructions: [
                    "Coloca la piedra para pizza o una bandeja pesada boca abajo en la rejilla m\xe1s alta.",
                    "Enciende el horno a la temperatura m\xe1xima: 250\u2013280 \xb0C (480\u2013540 \xb0F).",
                    "Precalienta al menos 45 minutos \u2014 la piedra o bandeja debe estar muy caliente.",
                    "\uD83D\uDCA1 El calor acumulado en la piedra es lo que da la base crujiente y el borde aireado.",
                    'Mientras precalienta, prepara los toppings (salsa, queso, ingredientes).',
                    "Mant\xe9n los toppings ligeros \u2014 demasiado peso aplana las burbujas del borde."
                ]
            },
            {
                id: 'p3-d2-a3',
                day: 2,
                timeOffset: 14.25,
                action: 'Estirar la Masa',
                description: 'Aplana con las manos desde el centro dejando el borde grueso.',
                duration: '10 min',
                emoji: "\uD83D\uDC50",
                instructions: [
                    'Enharina muy ligeramente la superficie y toma una bola de masa.',
                    "Con los dedos, presiona desde el centro hacia afuera formando un c\xedrculo.",
                    "Levanta la masa y est\xedrala con los nudillos, girando mientras la dejas caer.",
                    "Deja el borde exterior m\xe1s grueso (1\u20132 cm) \u2014 ah\xed estar\xe1n las burbujas.",
                    "\u26A0\uFE0F No uses rodillo en el borde: lo aplana y pierde el aire.",
                    "\uD83D\uDCA1 Si la masa se retrae, d\xe9jala reposar 5 min y vuelve a intentarlo.",
                    "Objetivo: disco de 28\u201330 cm, m\xe1s fino en el centro y m\xe1s grueso en el borde.",
                    'Transfiere a papel pergamino o pala enharinada con semolina para el horneado.'
                ]
            },
            {
                id: 'p3-d2-a4',
                day: 2,
                timeOffset: 14.5,
                action: 'Montar y Hornear',
                description: "A\xf1ade toppings y hornea 7\u201310 min hasta borde dorado.",
                duration: '10 min',
                emoji: "\uD83C\uDF55",
                instructions: [
                    "Con la masa estirada sobre el papel pergamino, a\xf1ade una capa fina de salsa (no excedas los bordes).",
                    "Agrega queso y toppings \u2014 ligeros y en capas finas para un horneado parejo.",
                    'Desliza la pizza (con el papel) sobre la piedra o bandeja caliente.',
                    "Hornea 7\u201310 minutos: el borde debe estar dorado y con manchas oscuras, la base tostada.",
                    "\uD83D\uDCA1 En hornos caseros a 250 \xb0C, 8\u20139 min suele ser perfecto.",
                    'Retira con la pala o con pinzas y el papel.',
                    "Deja reposar 1\u20132 min antes de cortar para que el queso se asiente.",
                    "\xa1Disfruta tu pizza de masa madre! \uD83C\uDF55\u2728"
                ]
            }
        ]
    }
};
const $deb185f198c84388$export$a4ca1752b438d9b6 = [
    "\xa1Tu masa est\xe1 creciendo! \uD83C\uDF31",
    "\xa1Paciencia, panadero! \uD83D\uDD50",
    "\xa1Las bacterias trabajan duro! \uD83E\uDDA0",
    "\xa1Pronto tendr\xe1s un pan incre\xedble! \uD83C\uDF5E",
    "\xa1La fermentaci\xf3n es magia lenta! \u2728",
    "\xa1Tu cultivo est\xe1 vivo! \u2764\uFE0F",
    "\xa1Cada alimentaci\xf3n cuenta! \uD83D\uDCAA",
    "La naturaleza sigue su ritmo \uD83C\uDF3F",
    "\xa1Eres un maestro panadero! \uD83D\uDC68\u200D\uD83C\uDF73",
    "\xa1El aroma ser\xe1 incre\xedble! \uD83D\uDC43"
];


// ============================================================
//  MASAMADREAM — UI helpers
// ============================================================
/**
 * Show a named screen, hiding all others.
 * @param {'home' | 'dashboard'} name
 */ function $2faff07f6008cb7d$export$c71b571bc504786c(name) {
    document.querySelectorAll('.mm-screen').forEach((el)=>{
        el.classList.remove('is-active');
    });
    const target = document.getElementById(`mm-screen-${name}`);
    if (target) target.classList.add('is-active');
}
function $2faff07f6008cb7d$export$cbe0d99836e1498f(id, value) {
    const el = document.getElementById(id);
    if (el) el.textContent = value;
}
function $2faff07f6008cb7d$export$8cb512849e51eaf5(id, visible) {
    const el = document.getElementById(id);
    if (!el) return;
    if (visible) el.classList.remove('mm-hidden');
    else el.classList.add('mm-hidden');
}
function $2faff07f6008cb7d$export$4f0eff23342a9a3b(ms) {
    if (ms === null || ms === undefined) return '--:--:--';
    if (ms <= 0) return "\xa1Ahora!";
    const totalSecs = Math.floor(ms / 1000);
    const h = Math.floor(totalSecs / 3600);
    const m = Math.floor(totalSecs % 3600 / 60);
    const s = totalSecs % 60;
    return [
        h,
        m,
        s
    ].map((n)=>String(n).padStart(2, '0')).join(':');
}


// ============================================================
//  MASAMADREAM — Toast notifications
// ============================================================
const $92c4faff7f0429a4$var$DURATION = 3000; // ms
function $92c4faff7f0429a4$export$b410431fab84fa58(message, duration = $92c4faff7f0429a4$var$DURATION) {
    const container = document.getElementById('mm-toast-container');
    if (!container) return;
    const el = document.createElement('div');
    el.className = 'mm-toast';
    el.textContent = message;
    container.appendChild(el);
    setTimeout(()=>{
        el.classList.add('is-hiding');
        el.addEventListener('animationend', ()=>el.remove(), {
            once: true
        });
    }, duration);
}


// ============================================================
//  MASAMADREAM — Countdown Timer
//  Fase 3: shows next activity name, pulses when due
// ============================================================


let $de59b905778ac270$var$_intervalId = null;
function $de59b905778ac270$export$1ad018ea9ed1d4c7(process, store) {
    $de59b905778ac270$export$9caf03b53d8b893a();
    const pData = (0, $deb185f198c84388$export$ffa50ca9b2a96ffa)[process.type];
    if (!pData) return;
    function tick() {
        const state = store.load();
        const active = state.activeProcess;
        if (!active) {
            $de59b905778ac270$export$9caf03b53d8b893a();
            return;
        }
        // Current day label
        (0, $2faff07f6008cb7d$export$cbe0d99836e1498f)('mm-current-day-label', `D\xcdA ${active.currentDay}`);
        // Find next incomplete activity
        const next = $de59b905778ac270$var$_findNextActivity(active, pData.activities);
        const timerEl = document.getElementById('mm-countdown-timer');
        const nameEl = document.getElementById('mm-countdown-name');
        if (!next) {
            // All done
            if (timerEl) {
                timerEl.textContent = "\xa1Proceso completo! \uD83C\uDF89";
                timerEl.style.color = 'var(--mm-green)';
            }
            if (nameEl) nameEl.textContent = '';
            $de59b905778ac270$export$9caf03b53d8b893a();
            return;
        }
        const remaining = next.scheduledAt - Date.now();
        if (nameEl) nameEl.textContent = `Pr\xf3xima: ${next.action}`;
        if (timerEl) {
            if (remaining <= 0) {
                // Overdue — pulse
                timerEl.textContent = "\xa1Ahora! \uD83C\uDF5E";
                timerEl.classList.add('is-due');
                timerEl.style.color = '';
            } else {
                timerEl.classList.remove('is-due');
                timerEl.textContent = (0, $2faff07f6008cb7d$export$4f0eff23342a9a3b)(remaining);
                // Warning color < 30 min
                timerEl.style.color = remaining < 1800000 ? '#E65100' : '';
            }
        }
    }
    tick();
    $de59b905778ac270$var$_intervalId = setInterval(tick, 1000);
}
function $de59b905778ac270$export$9caf03b53d8b893a() {
    if ($de59b905778ac270$var$_intervalId !== null) {
        clearInterval($de59b905778ac270$var$_intervalId);
        $de59b905778ac270$var$_intervalId = null;
    }
}
// ── Helpers ───────────────────────────────────────────────────
function $de59b905778ac270$var$_findNextActivity(activeProcess, activities) {
    const start = new Date(activeProcess.startDate).getTime();
    const completedIds = activeProcess.completedIds;
    return activities.filter((a)=>!completedIds.includes(a.id)).map((a)=>({
            ...a,
            scheduledAt: start + a.timeOffset * 3600000
        })).sort((a, b)=>a.scheduledAt - b.scheduledAt)[0] || null;
}


// ============================================================
//  MASAMADREAM — Activities Card
//  Fase 3+: checkbox = toggle, row click = open instructions modal
// ============================================================


// ============================================================
//  MASAMADREAM — Activity Modal (Bottom Sheet)
//  Muestra instrucciones paso a paso de una actividad
// ============================================================

let $260696580986d9c4$var$_currentActivity = null;
let $260696580986d9c4$var$_onComplete = null;
// Timer state
let $260696580986d9c4$var$_timerInterval = null;
let $260696580986d9c4$var$_timerSeconds = 0;
let $260696580986d9c4$var$_timerActivityId = null;
let $260696580986d9c4$var$_timerOnCompleteCallback = null;
function $260696580986d9c4$export$130abcd381f729aa(activity, isCompleted, onComplete) {
    $260696580986d9c4$var$_currentActivity = activity;
    $260696580986d9c4$var$_onComplete = onComplete;
    $260696580986d9c4$var$_timerOnCompleteCallback = onComplete;
    const backdrop = document.getElementById('mm-activity-modal');
    if (!backdrop) return;
    // Populate content
    $260696580986d9c4$var$_fill(activity, isCompleted);
    // Show
    backdrop.classList.remove('mm-hidden');
    requestAnimationFrame(()=>{
        backdrop.classList.add('is-open');
    });
    // Prevent body scroll
    document.body.style.overflow = 'hidden';
}
function $260696580986d9c4$export$cd771328f3445c13() {
    const backdrop = document.getElementById('mm-activity-modal');
    if (!backdrop) return;
    backdrop.classList.remove('is-open');
    backdrop.addEventListener('transitionend', ()=>{
        backdrop.classList.add('mm-hidden');
        document.body.style.overflow = '';
        $260696580986d9c4$var$_currentActivity = null;
        $260696580986d9c4$var$_timerOnCompleteCallback = null;
        $260696580986d9c4$var$_stopTimer();
    }, {
        once: true
    });
}
// ── Fill content ──────────────────────────────────────────────
function $260696580986d9c4$var$_fill(act, isCompleted) {
    $260696580986d9c4$var$_setText('mm-modal-emoji', act.emoji || "\uD83D\uDCCB");
    $260696580986d9c4$var$_setText('mm-modal-action', act.action);
    $260696580986d9c4$var$_setText('mm-modal-duration', `\u{23F1} ${act.duration}`);
    $260696580986d9c4$var$_setText('mm-modal-desc', act.description);
    // Initialize timer UI for this activity
    $260696580986d9c4$var$_initTimerForActivity(act);
    // Day badge
    const badge = document.getElementById('mm-modal-day-badge');
    if (badge) badge.textContent = `D\xeda ${act.day}`;
    // Steps
    const list = document.getElementById('mm-modal-steps');
    if (list) {
        list.innerHTML = '';
        (act.instructions || []).forEach((step, i)=>{
            const li = document.createElement('li');
            li.className = 'mm-modal-step';
            // Steps that start with • or 💡 get special styling
            if (step.startsWith("\uD83D\uDCA1")) {
                li.className += ' mm-modal-step--tip';
                li.textContent = step;
            } else if (step.startsWith("\u2022") || step.match(/^[0-9]+ g|^[0-9]+ ml/)) {
                li.className += ' mm-modal-step--ingredient';
                li.textContent = step;
            } else {
                const num = document.createElement('span');
                num.className = 'mm-modal-step-num';
                num.textContent = i + 1;
                li.appendChild(num);
                const txt = document.createElement('span');
                txt.textContent = step;
                li.appendChild(txt);
            }
            list.appendChild(li);
        });
    }
    // Complete button state
    const btn = document.getElementById('mm-modal-complete-btn');
    if (btn) {
        if (isCompleted) {
            btn.textContent = "\u21A9\uFE0F Desmarcar";
            btn.classList.remove('mm-btn--primary');
            btn.classList.add('mm-btn--outline');
        } else {
            btn.textContent = "\u2713 Marcar como completado";
            btn.classList.add('mm-btn--primary');
            btn.classList.remove('mm-btn--outline');
        }
    }
}
function $260696580986d9c4$export$e2528e2f8783b5e2() {
    const backdrop = document.getElementById('mm-activity-modal');
    const sheet = document.getElementById('mm-modal-sheet');
    // Close on backdrop click
    backdrop?.addEventListener('click', (e)=>{
        if (e.target === backdrop) $260696580986d9c4$export$cd771328f3445c13();
    });
    // Close button
    document.getElementById('mm-modal-close')?.addEventListener('click', $260696580986d9c4$export$cd771328f3445c13);
    // ESC key
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape') $260696580986d9c4$export$cd771328f3445c13();
    });
    // Complete button
    document.getElementById('mm-modal-complete-btn')?.addEventListener('click', ()=>{
        if ($260696580986d9c4$var$_currentActivity && $260696580986d9c4$var$_onComplete) {
            $260696580986d9c4$var$_onComplete($260696580986d9c4$var$_currentActivity);
            $260696580986d9c4$export$cd771328f3445c13();
        }
    });
    // Touch swipe-down to close
    let _startY = 0;
    sheet?.addEventListener('touchstart', (e)=>{
        _startY = e.touches[0].clientY;
    }, {
        passive: true
    });
    sheet?.addEventListener('touchend', (e)=>{
        const delta = e.changedTouches[0].clientY - _startY;
        if (delta > 60) $260696580986d9c4$export$cd771328f3445c13(); // swipe down > 60px
    }, {
        passive: true
    });
}
// ── Util ──────────────────────────────────────────────────────
function $260696580986d9c4$var$_setText(id, val) {
    const el = document.getElementById(id);
    if (el) el.textContent = val;
}
// ── Timer ──────────────────────────────────────────────────────
function $260696580986d9c4$var$_parseDurationToMinutes(durationStr) {
    if (!durationStr) return 0;
    const str = durationStr.toLowerCase();
    // Handle ranges like "1–2 horas" or "12–16 horas"
    const rangeMatch = str.match(/(\d+)[–-](\d+)\s*(hora|horas|min)/);
    if (rangeMatch) return parseInt(rangeMatch[2]) * (str.includes('hora') ? 60 : 1);
    // Handle "X hora" or "X horas"
    const hourMatch = str.match(/(\d+)\s*hora?s?/);
    if (hourMatch) return parseInt(hourMatch[1]) * 60;
    // Handle "X min" or "X minuto(s)"
    const minMatch = str.match(/(\d+)\s*min/);
    if (minMatch) return parseInt(minMatch[1]);
    return 10; // default fallback
}
function $260696580986d9c4$var$_initTimerForActivity(act) {
    const display = document.getElementById('mm-timer-display');
    const btn = document.getElementById('mm-timer-start-btn');
    if (!display || !btn) return;
    // Clear any existing timer
    $260696580986d9c4$var$_stopTimer();
    $260696580986d9c4$var$_timerActivityId = act.id;
    const minutes = $260696580986d9c4$var$_parseDurationToMinutes(act.duration);
    $260696580986d9c4$var$_timerSeconds = minutes * 60;
    display.textContent = $260696580986d9c4$var$_formatTime($260696580986d9c4$var$_timerSeconds);
    display.classList.remove('is-active', 'is-done');
    btn.textContent = "\u23F1 Iniciar timer";
    btn.classList.remove('mm-btn--primary');
    btn.classList.add('mm-btn--outline');
    btn.onclick = ()=>{
        if ($260696580986d9c4$var$_timerInterval) $260696580986d9c4$var$_stopTimer();
        else $260696580986d9c4$var$_startTimer();
    };
}
function $260696580986d9c4$var$_startTimer() {
    const display = document.getElementById('mm-timer-display');
    const btn = document.getElementById('mm-timer-start-btn');
    if (!display || !btn) return;
    display.classList.add('is-active');
    btn.textContent = "\u23F9 Detener";
    btn.classList.remove('mm-btn--outline');
    btn.classList.add('mm-btn--primary');
    $260696580986d9c4$var$_timerInterval = setInterval(()=>{
        $260696580986d9c4$var$_timerSeconds--;
        display.textContent = $260696580986d9c4$var$_formatTime($260696580986d9c4$var$_timerSeconds);
        if ($260696580986d9c4$var$_timerSeconds <= 0) $260696580986d9c4$var$_onTimerComplete();
    }, 1000);
}
function $260696580986d9c4$var$_stopTimer() {
    if ($260696580986d9c4$var$_timerInterval) {
        clearInterval($260696580986d9c4$var$_timerInterval);
        $260696580986d9c4$var$_timerInterval = null;
    }
}
function $260696580986d9c4$var$_onTimerComplete() {
    $260696580986d9c4$var$_stopTimer();
    const display = document.getElementById('mm-timer-display');
    const btn = document.getElementById('mm-timer-start-btn');
    if (display) {
        display.textContent = "\xa1Listo!";
        display.classList.remove('is-active');
        display.classList.add('is-done');
    }
    if (btn) {
        btn.textContent = "\uD83D\uDD04 Reiniciar";
        btn.classList.remove('mm-btn--primary');
        btn.classList.add('mm-btn--outline');
    }
    // Play alarm sound
    $260696580986d9c4$var$_playAlarm();
    // Mark activity as completed via callback
    if ($260696580986d9c4$var$_timerOnCompleteCallback && $260696580986d9c4$var$_currentActivity) $260696580986d9c4$var$_timerOnCompleteCallback($260696580986d9c4$var$_currentActivity);
    // Show toast notification
    if ($260696580986d9c4$var$_currentActivity) (0, $92c4faff7f0429a4$export$b410431fab84fa58)(`\u{23F0} Timer de "${$260696580986d9c4$var$_currentActivity.action}" terminado!`, 5000);
}
function $260696580986d9c4$var$_formatTime(totalSeconds) {
    const mins = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
}
function $260696580986d9c4$var$_playAlarm() {
    try {
        const ctx = new (window.AudioContext || window.webkitAudioContext)();
        const duration = 0.15;
        const now = ctx.currentTime;
        // Play 3 beeps
        for(let i = 0; i < 3; i++){
            const osc = ctx.createOscillator();
            const gain = ctx.createGain();
            osc.connect(gain);
            gain.connect(ctx.destination);
            osc.frequency.value = 800;
            osc.type = 'sine';
            const startTime = now + i * 0.3;
            gain.gain.setValueAtTime(0.3, startTime);
            gain.gain.exponentialRampToValueAtTime(0.01, startTime + duration);
            osc.start(startTime);
            osc.stop(startTime + duration);
        }
    } catch (e) {
        console.warn('Audio not supported:', e);
    }
}
function $260696580986d9c4$export$36f84eab73a50610() {
    $260696580986d9c4$var$_stopTimer();
}


function $ef4d3d31fc602be9$export$574469e75e19ecfe(process, store, onDayComplete) {
    const container = document.getElementById('mm-activities-body');
    if (!container) return;
    const pData = (0, $deb185f198c84388$export$ffa50ca9b2a96ffa)[process.type];
    if (!pData) return;
    // Re-fetch the process from store to get fresh data
    const freshProcess = store.getProcess(process.id);
    if (!freshProcess) return;
    process = freshProcess;
    // Group by day
    const byDay = {};
    pData.activities.forEach((act)=>{
        (byDay[act.day] = byDay[act.day] || []).push(act);
    });
    container.innerHTML = '';
    Object.entries(byDay).forEach(([day, acts])=>{
        const dayNum = parseInt(day, 10);
        const isToday = dayNum === process.currentDay;
        const isPast = dayNum < process.currentDay;
        const isFuture = dayNum > process.currentDay;
        const doneCount = acts.filter((a)=>store.isCompleted(a.id, process.id)).length;
        const totalCount = acts.length;
        const dayDone = doneCount === totalCount;
        // ── Day group ─────────────────────────────────────────
        const group = document.createElement('div');
        group.className = 'mm-activity-day';
        // ── Day header ────────────────────────────────────────
        const header = document.createElement('div');
        header.className = 'mm-activity-day-header';
        const lbl = document.createElement('span');
        lbl.className = 'mm-activity-day-label';
        lbl.textContent = `D\xeda ${day}`;
        if (isToday && !dayDone) lbl.style.color = 'var(--mm-blue)';
        if (dayDone) lbl.style.color = 'var(--mm-green)';
        const badge = document.createElement('span');
        badge.className = `mm-activity-badge ${dayDone ? 'is-done' : isToday ? 'is-today' : ''}`;
        badge.textContent = `${doneCount}/${totalCount}`;
        header.appendChild(lbl);
        header.appendChild(badge);
        group.appendChild(header);
        // ── Activity rows ─────────────────────────────────────
        acts.forEach((act)=>{
            const done = store.isCompleted(act.id, process.id);
            const tappable = isToday || isPast;
            const item = document.createElement('div');
            item.className = [
                'mm-activity-item',
                done ? 'is-done' : '',
                isToday && !done ? 'is-active' : '',
                isFuture ? 'is-future' : ''
            ].filter(Boolean).join(' ');
            item.setAttribute('role', 'button');
            item.setAttribute('tabindex', tappable ? '0' : '-1');
            item.setAttribute('aria-label', `${act.action} \u{2014} ver instrucciones`);
            // Checkbox
            const box = document.createElement('div');
            box.className = [
                'mm-checkbox',
                done ? 'is-done' : '',
                isToday && !done ? 'is-active' : '',
                isFuture ? 'is-future' : ''
            ].filter(Boolean).join(' ');
            box.setAttribute('role', 'checkbox');
            box.setAttribute('aria-checked', done ? 'true' : 'false');
            box.setAttribute('aria-label', `Marcar ${act.action}`);
            box.setAttribute('tabindex', '-1'); // handled by parent
            if (done) box.textContent = "\u2713";
            // Info
            const info = document.createElement('div');
            info.className = 'mm-activity-info';
            const name = document.createElement('div');
            name.className = 'mm-activity-name';
            name.textContent = `${act.emoji || ''} ${act.action}`.trim();
            const desc = document.createElement('div');
            desc.className = 'mm-activity-desc';
            desc.textContent = act.duration;
            info.appendChild(name);
            info.appendChild(desc);
            // Chevron (indicates modal opens on tap)
            const chevron = document.createElement('span');
            chevron.className = 'mm-activity-chevron';
            chevron.setAttribute('aria-hidden', 'true');
            chevron.textContent = "\u203A";
            item.appendChild(box);
            item.appendChild(info);
            if (!isFuture) item.appendChild(chevron);
            group.appendChild(item);
            // ── Event handlers ───────────────────────────────────
            if (tappable) {
                // Checkbox click: toggle completion (stop propagation so row doesn't also fire)
                box.addEventListener('click', (e)=>{
                    e.stopPropagation();
                    $ef4d3d31fc602be9$var$_toggleActivity(act, done, store, acts, isToday, process, onDayComplete);
                });
                // Row click: open modal with instructions
                item.addEventListener('click', ()=>{
                    (0, $260696580986d9c4$export$130abcd381f729aa)(act, store.isCompleted(act.id, process.id), (a)=>{
                        // Called from modal "Marcar completo / Desmarcar" button
                        // Toggle: if currently done, uncomplete; if not done, complete
                        const currentlyDone = store.isCompleted(a.id, process.id);
                        $ef4d3d31fc602be9$var$_toggleActivity(a, currentlyDone, store, acts, isToday, process, onDayComplete);
                    });
                });
                // Keyboard: Enter/Space opens modal
                item.addEventListener('keydown', (e)=>{
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        item.click();
                    }
                });
            }
        });
        container.appendChild(group);
    });
}
// ── Toggle logic (shared by checkbox + modal button) ─────────
function $ef4d3d31fc602be9$var$_toggleActivity(act, wasDone, store, dayActs, isToday, process, onDayComplete) {
    if (wasDone) {
        store.uncompleteActivity(act.id, process.id);
        (0, $92c4faff7f0429a4$export$b410431fab84fa58)(`\u{21A9}\u{FE0F} ${act.action} desmarcado`);
    } else {
        store.completeActivity(act.id, process.id);
        (0, $92c4faff7f0429a4$export$b410431fab84fa58)(`\u{2705} ${act.action} \xa1listo!`);
    }
    const fresh = store.load();
    const freshProcess = fresh.processes?.find((p)=>p.id === process.id);
    if (freshProcess) $ef4d3d31fc602be9$export$574469e75e19ecfe(freshProcess, store, onDayComplete);
    // Day complete check
    if (!wasDone && onDayComplete && isToday) {
        const totalDays = (0, $deb185f198c84388$export$ffa50ca9b2a96ffa)[process.type]?.totalDays ?? 7;
        const allDone = dayActs.every((a)=>store.isCompleted(a.id, process.id));
        if (allDone) onDayComplete(process.currentDay, totalDays);
    }
}


// ============================================================
//  MASAMADREAM — Notifications Card + Web Notifications
//  Sistema robusto con persistencia en localStorage
// ============================================================

const $1eab08be386b9a1b$var$NOTIF_STORAGE_KEY = 'masagotchi_notifications';
const $1eab08be386b9a1b$var$ICONS = {
    'Mezcla Inicial': "\uD83E\uDD63",
    'Alimentar': "\uD83C\uDF3E",
    'Alimentar y Verificar': "\uD83E\uDDEA",
    'Pliegues': "\uD83E\uDD32",
    "Formaci\xf3n de Hogazas": "\uD83E\uDED3",
    'Reposo Inicial': "\uD83D\uDCA4",
    'Sacar y Reposar': "\u23F1\uFE0F",
    'Precalentar Horno': "\uD83D\uDD25",
    'Hornear Tapado': "\uD83C\uDF73",
    'Hornear Destapado': "\uD83E\uDD50",
    'Reposo Final': "\uD83C\uDF89",
    'Pesar Ingredientes': "\u2696\uFE0F",
    'Mezcla Inicial': "\uD83E\uDED9",
    'Agregar Harina y Sal': "\uD83E\uDDC2",
    default: "\uD83D\uDCE8"
};
function $1eab08be386b9a1b$var$icon(action) {
    return $1eab08be386b9a1b$var$ICONS[action] || $1eab08be386b9a1b$var$ICONS.default;
}
function $1eab08be386b9a1b$var$fmt(iso, offsetHours) {
    const d = new Date(new Date(iso).getTime() + offsetHours * 3600000);
    return d.toLocaleTimeString('es-CR', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
}
// ── Storage: Save/Load scheduled notifications ───────────────────
function $1eab08be386b9a1b$var$_getStoredNotifs() {
    try {
        return JSON.parse(localStorage.getItem($1eab08be386b9a1b$var$NOTIF_STORAGE_KEY)) || [];
    } catch  {
        return [];
    }
}
function $1eab08be386b9a1b$var$_saveStoredNotifs(notifs) {
    try {
        localStorage.setItem($1eab08be386b9a1b$var$NOTIF_STORAGE_KEY, JSON.stringify(notifs));
    } catch (e) {
        console.warn('[MM] Failed to save notifications:', e);
    }
}
function $1eab08be386b9a1b$var$_saveNotificationsForProcess(processId, activities, startDate) {
    const existing = $1eab08be386b9a1b$var$_getStoredNotifs().filter((n)=>n.processId !== processId);
    activities.forEach((act)=>{
        const scheduledAt = new Date(startDate).getTime() + act.timeOffset * 3600000;
        if (scheduledAt > Date.now()) existing.push({
            id: `${processId}_${act.id}`,
            processId: processId,
            activityId: act.id,
            day: act.day,
            action: act.action,
            emoji: act.emoji,
            description: act.description,
            scheduledAt: scheduledAt,
            fired: false
        });
    });
    $1eab08be386b9a1b$var$_saveStoredNotifs(existing);
}
function $1eab08be386b9a1b$export$c677a7e6b63195e2(process) {
    const container = document.getElementById('mm-notifications-body');
    if (!container) return;
    const pData = (0, $deb185f198c84388$export$ffa50ca9b2a96ffa)[process.type];
    if (!pData) return;
    const now = Date.now();
    const start = new Date(process.startDate).getTime();
    // Split by day, mark each as past/upcoming
    const byDay = {};
    pData.activities.forEach((act)=>{
        const scheduledAt = start + act.timeOffset * 3600000;
        const state = scheduledAt < now ? 'past' : 'upcoming';
        (byDay[act.day] = byDay[act.day] || []).push({
            ...act,
            scheduledAt: scheduledAt,
            state: state
        });
    });
    // Count upcoming
    const upcomingCount = pData.activities.filter((a)=>start + a.timeOffset * 3600000 > now).length;
    // Update card header badge
    const headerEl = document.querySelector('#mm-card-notifications .mm-card-header .mm-card-icon');
    if (headerEl) headerEl.textContent = upcomingCount > 0 ? `\u{1F514} ${upcomingCount}` : "\uD83D\uDD15";
    container.innerHTML = '';
    Object.entries(byDay).forEach(([day, acts])=>{
        const group = document.createElement('div');
        group.className = 'mm-notif-day';
        const dayLabel = document.createElement('div');
        dayLabel.className = 'mm-notif-day-label';
        dayLabel.textContent = `D\xeda ${day}`;
        group.appendChild(dayLabel);
        acts.forEach((act)=>{
            const item = document.createElement('div');
            item.className = `mm-notif-item ${act.state === 'past' ? 'is-past' : 'is-upcoming'}`;
            item.innerHTML = `
        <span class="mm-notif-icon" aria-hidden="true">${$1eab08be386b9a1b$var$icon(act.action)}</span>
        <span class="mm-notif-time">${$1eab08be386b9a1b$var$fmt(process.startDate, act.timeOffset)}</span>
        <span class="mm-notif-action">${act.action}</span>
        ${act.state === 'past' ? '<span class="mm-notif-sent" aria-label="Enviada">\u2713</span>' : '<span class="mm-notif-dot" aria-hidden="true"></span>'}
      `;
            group.appendChild(item);
        });
        container.appendChild(group);
    });
}
async function $1eab08be386b9a1b$export$eac83ef81709efc5(process) {
    if (!('Notification' in window)) return;
    // Request permission if needed
    if (Notification.permission === 'default') {
        const r = await Notification.requestPermission();
        if (r !== 'granted') return;
    }
    if (Notification.permission !== 'granted') return;
    const pData = (0, $deb185f198c84388$export$ffa50ca9b2a96ffa)[process.type];
    if (!pData) return;
    // Save to localStorage for persistence
    $1eab08be386b9a1b$var$_saveNotificationsForProcess(process.id, pData.activities, process.startDate);
    // Schedule the notifications
    $1eab08be386b9a1b$export$45477eed36a452d4();
}
function $1eab08be386b9a1b$export$45477eed36a452d4() {
    if (Notification.permission !== 'granted') return;
    const notifs = $1eab08be386b9a1b$var$_getStoredNotifs();
    const now = Date.now();
    notifs.forEach((notif)=>{
        if (notif.fired) return;
        const delay = notif.scheduledAt - now;
        if (delay <= 0) {
            // Already past, fire immediately
            $1eab08be386b9a1b$var$_fireNotification(notif, true);
            return;
        }
        // Schedule future notification
        setTimeout(()=>{
            $1eab08be386b9a1b$var$_fireNotification(notif, true);
        }, delay);
    });
}
function $1eab08be386b9a1b$var$_fireNotification(notif, markFired = false) {
    if (Notification.permission !== 'granted') return;
    new Notification(`MASAGOTCHI \u{2014} D\xeda ${notif.day} \u{1F35E}`, {
        body: `${notif.emoji || ''} ${notif.action}: ${notif.description}`.trim(),
        icon: '/assets/logo.png',
        tag: notif.id,
        vibrate: [
            200,
            100,
            200
        ],
        badge: '/assets/logo.png'
    });
    if (markFired) {
        const notifs = $1eab08be386b9a1b$var$_getStoredNotifs();
        const idx = notifs.findIndex((n)=>n.id === notif.id);
        if (idx !== -1) {
            notifs[idx].fired = true;
            $1eab08be386b9a1b$var$_saveStoredNotifs(notifs);
        }
    }
}
function $1eab08be386b9a1b$export$6957c77dcbb1ab7e(processId) {
    const notifs = $1eab08be386b9a1b$var$_getStoredNotifs().filter((n)=>n.processId !== processId);
    $1eab08be386b9a1b$var$_saveStoredNotifs(notifs);
}


// ============================================================
//  MASAMADREAM — Circular Dial (SVG)
//  Fase 2: 7-segment clock, progress arc, mascot center, phrases
// ============================================================

const $1afced4d205e7b8e$var$NS = 'http://www.w3.org/2000/svg';
// SVG geometry constants
const $1afced4d205e7b8e$var$CX = 150; // center x
const $1afced4d205e7b8e$var$CY = 150; // center y
const $1afced4d205e7b8e$var$R_OUTER = 143; // outer edge of day-ring
const $1afced4d205e7b8e$var$R_INNER = 102; // inner edge of day-ring
const $1afced4d205e7b8e$var$R_LABEL = 122; // midpoint of ring (day text)
const $1afced4d205e7b8e$var$R_PROGRESS = 108; // progress arc radius
const $1afced4d205e7b8e$var$R_CENTER = 96; // center circle radius
var $8cc8fb069d672030$exports = {};
$8cc8fb069d672030$exports = $parcel$resolve("gU4WN");


// Logo URL (resolved by Parcel at build time)
const $1afced4d205e7b8e$var$LOGO_URL = new URL($8cc8fb069d672030$exports);
// ── Helpers ───────────────────────────────────────────────────
function $1afced4d205e7b8e$var$svgEl(tag, attrs = {}) {
    const node = document.createElementNS($1afced4d205e7b8e$var$NS, tag);
    for (const [k, v] of Object.entries(attrs))node.setAttribute(k, String(v));
    return node;
}
// 0° = 12 o'clock, positive = clockwise
function $1afced4d205e7b8e$var$toXY(r, deg) {
    const rad = (deg - 90) * Math.PI / 180;
    return [
        $1afced4d205e7b8e$var$CX + r * Math.cos(rad),
        $1afced4d205e7b8e$var$CY + r * Math.sin(rad)
    ];
}
// SVG arc path between two angles at radius r
function $1afced4d205e7b8e$var$arcPath(r, a1, a2) {
    const [x1, y1] = $1afced4d205e7b8e$var$toXY(r, a1);
    const [x2, y2] = $1afced4d205e7b8e$var$toXY(r, a2);
    const large = a2 - a1 > 180 ? 1 : 0;
    return `M ${x1.toFixed(3)} ${y1.toFixed(3)} A ${r} ${r} 0 ${large} 1 ${x2.toFixed(3)} ${y2.toFixed(3)}`;
}
// Donut sector path (outer arc CW → inner arc CCW)
function $1afced4d205e7b8e$var$sectorPath(a1, a2) {
    const [ox1, oy1] = $1afced4d205e7b8e$var$toXY($1afced4d205e7b8e$var$R_OUTER, a1);
    const [ox2, oy2] = $1afced4d205e7b8e$var$toXY($1afced4d205e7b8e$var$R_OUTER, a2);
    const [ix1, iy1] = $1afced4d205e7b8e$var$toXY($1afced4d205e7b8e$var$R_INNER, a1);
    const [ix2, iy2] = $1afced4d205e7b8e$var$toXY($1afced4d205e7b8e$var$R_INNER, a2);
    const large = a2 - a1 > 180 ? 1 : 0;
    return [
        `M ${ox1.toFixed(3)} ${oy1.toFixed(3)}`,
        `A ${$1afced4d205e7b8e$var$R_OUTER} ${$1afced4d205e7b8e$var$R_OUTER} 0 ${large} 1 ${ox2.toFixed(3)} ${oy2.toFixed(3)}`,
        `L ${ix2.toFixed(3)} ${iy2.toFixed(3)}`,
        `A ${$1afced4d205e7b8e$var$R_INNER} ${$1afced4d205e7b8e$var$R_INNER} 0 ${large} 0 ${ix1.toFixed(3)} ${iy1.toFixed(3)}`,
        'Z'
    ].join(' ');
}
function $1afced4d205e7b8e$export$13e1610f74a4e03(process) {
    const pData = (0, $deb185f198c84388$export$ffa50ca9b2a96ffa)[process.type];
    const totalDays = pData.totalDays;
    const curDay = Math.max(1, Math.min(process.currentDay, totalDays));
    const segAngle = 360 / totalDays;
    const progAngle = (curDay - 1) / totalDays * 360; // degrees filled
    const svg = $1afced4d205e7b8e$var$svgEl('svg', {
        viewBox: '0 0 300 300',
        width: '300',
        height: '300',
        role: 'img',
        'aria-label': `Progreso: D\xeda ${curDay} de ${totalDays}`,
        class: 'mm-dial-svg'
    });
    // ── Defs ────────────────────────────────────────────────────
    const defs = $1afced4d205e7b8e$var$svgEl('defs');
    // Progress gradient
    const grad = $1afced4d205e7b8e$var$svgEl('linearGradient', {
        id: 'mm-pg',
        gradientUnits: 'userSpaceOnUse',
        x1: $1afced4d205e7b8e$var$CX,
        y1: $1afced4d205e7b8e$var$CY - $1afced4d205e7b8e$var$R_PROGRESS,
        x2: $1afced4d205e7b8e$var$CX + $1afced4d205e7b8e$var$R_PROGRESS,
        y2: $1afced4d205e7b8e$var$CY + $1afced4d205e7b8e$var$R_PROGRESS / 2
    });
    const s1 = $1afced4d205e7b8e$var$svgEl('stop', {
        offset: '0%'
    });
    s1.style.cssText = 'stop-color:#90CAF9';
    const s2 = $1afced4d205e7b8e$var$svgEl('stop', {
        offset: '100%'
    });
    s2.style.cssText = 'stop-color:#1565C0';
    grad.appendChild(s1);
    grad.appendChild(s2);
    defs.appendChild(grad);
    // Center drop shadow
    const filt = $1afced4d205e7b8e$var$svgEl('filter', {
        id: 'mm-shadow',
        x: '-15%',
        y: '-15%',
        width: '130%',
        height: '130%'
    });
    filt.appendChild($1afced4d205e7b8e$var$svgEl('feDropShadow', {
        dx: '0',
        dy: '3',
        stdDeviation: '5',
        'flood-color': 'rgba(109,76,65,0.18)'
    }));
    defs.appendChild(filt);
    // Clip for center logo (circle)
    const clip = $1afced4d205e7b8e$var$svgEl('clipPath', {
        id: 'mm-logo-clip'
    });
    clip.appendChild($1afced4d205e7b8e$var$svgEl('circle', {
        cx: $1afced4d205e7b8e$var$CX,
        cy: $1afced4d205e7b8e$var$CY - 6,
        r: '42'
    }));
    defs.appendChild(clip);
    svg.appendChild(defs);
    // ── Ring background ──────────────────────────────────────────
    const ringMid = ($1afced4d205e7b8e$var$R_OUTER + $1afced4d205e7b8e$var$R_INNER) / 2;
    const ringW = $1afced4d205e7b8e$var$R_OUTER - $1afced4d205e7b8e$var$R_INNER;
    svg.appendChild($1afced4d205e7b8e$var$svgEl('circle', {
        cx: $1afced4d205e7b8e$var$CX,
        cy: $1afced4d205e7b8e$var$CY,
        r: ringMid,
        fill: 'none',
        stroke: '#F0E8D8',
        'stroke-width': ringW
    }));
    // Ring borders
    svg.appendChild($1afced4d205e7b8e$var$svgEl('circle', {
        cx: $1afced4d205e7b8e$var$CX,
        cy: $1afced4d205e7b8e$var$CY,
        r: $1afced4d205e7b8e$var$R_OUTER,
        fill: 'none',
        stroke: '#D0C0A8',
        'stroke-width': '2'
    }));
    svg.appendChild($1afced4d205e7b8e$var$svgEl('circle', {
        cx: $1afced4d205e7b8e$var$CX,
        cy: $1afced4d205e7b8e$var$CY,
        r: $1afced4d205e7b8e$var$R_INNER,
        fill: 'none',
        stroke: '#D0C0A8',
        'stroke-width': '1'
    }));
    // ── Completed day sectors (green tint) ───────────────────────
    for(let i = 0; i < curDay - 1; i++){
        const a1 = i * segAngle;
        const a2 = (i + 1) * segAngle;
        svg.appendChild($1afced4d205e7b8e$var$svgEl('path', {
            d: $1afced4d205e7b8e$var$sectorPath(a1, a2),
            fill: 'rgba(67,160,71,0.14)'
        }));
    }
    // ── Active day sector (blue tint) ────────────────────────────
    {
        const a1 = (curDay - 1) * segAngle;
        const a2 = curDay * segAngle;
        svg.appendChild($1afced4d205e7b8e$var$svgEl('path', {
            d: $1afced4d205e7b8e$var$sectorPath(a1, a2),
            fill: 'rgba(33,150,243,0.13)'
        }));
    }
    // ── Segment dividers ─────────────────────────────────────────
    for(let i = 0; i < totalDays; i++){
        const angle = i * segAngle;
        const [x1, y1] = $1afced4d205e7b8e$var$toXY($1afced4d205e7b8e$var$R_INNER, angle);
        const [x2, y2] = $1afced4d205e7b8e$var$toXY($1afced4d205e7b8e$var$R_OUTER, angle);
        svg.appendChild($1afced4d205e7b8e$var$svgEl('line', {
            x1: x1.toFixed(3),
            y1: y1.toFixed(3),
            x2: x2.toFixed(3),
            y2: y2.toFixed(3),
            stroke: '#C8B090',
            'stroke-width': '1.5'
        }));
    }
    // ── Day labels ───────────────────────────────────────────────
    for(let i = 0; i < totalDays; i++){
        const dayNum = i + 1;
        const midAngle = i * segAngle + segAngle / 2;
        const [lx, ly] = $1afced4d205e7b8e$var$toXY($1afced4d205e7b8e$var$R_LABEL, midAngle);
        const isDone = dayNum < curDay;
        const isToday = dayNum === curDay;
        const fill = isToday ? '#1565C0' : isDone ? '#2E7D32' : '#6D4C41';
        const weight = isToday || isDone ? '700' : '600';
        const size = totalDays <= 7 ? '10.5' : '9.5';
        const g = $1afced4d205e7b8e$var$svgEl('g', {
            transform: `rotate(${midAngle}, ${lx.toFixed(3)}, ${ly.toFixed(3)})`
        });
        const t = $1afced4d205e7b8e$var$svgEl('text', {
            x: lx.toFixed(3),
            y: ly.toFixed(3),
            'text-anchor': 'middle',
            'dominant-baseline': 'central',
            fill: fill,
            'font-family': "'Signika Negative', sans-serif",
            'font-size': size,
            'font-weight': weight,
            'letter-spacing': '0.4'
        });
        // Show checkmark emoji for completed days
        t.textContent = isDone ? `\u{2713} D\xcdA ${dayNum}` : `D\xcdA ${dayNum}`;
        g.appendChild(t);
        svg.appendChild(g);
    }
    // ── Progress arc ─────────────────────────────────────────────
    if (progAngle > 0.5) {
        const clampedEnd = Math.min(progAngle, 359.9);
        const progEl = $1afced4d205e7b8e$var$svgEl('path', {
            d: $1afced4d205e7b8e$var$arcPath($1afced4d205e7b8e$var$R_PROGRESS, 0, clampedEnd),
            fill: 'none',
            stroke: 'url(#mm-pg)',
            'stroke-width': '8',
            'stroke-linecap': 'round',
            class: 'mm-dial-progress'
        });
        svg.appendChild(progEl);
        // Leading dot
        const [dx, dy] = $1afced4d205e7b8e$var$toXY($1afced4d205e7b8e$var$R_PROGRESS, progAngle);
        svg.appendChild($1afced4d205e7b8e$var$svgEl('circle', {
            cx: dx.toFixed(3),
            cy: dy.toFixed(3),
            r: '7',
            fill: '#2196F3',
            stroke: '#FFFFFF',
            'stroke-width': '2.5',
            filter: 'url(#mm-shadow)'
        }));
    }
    // ── Center circle ─────────────────────────────────────────────
    svg.appendChild($1afced4d205e7b8e$var$svgEl('circle', {
        cx: $1afced4d205e7b8e$var$CX,
        cy: $1afced4d205e7b8e$var$CY,
        r: $1afced4d205e7b8e$var$R_CENTER,
        fill: 'rgba(248,245,236,0.94)',
        filter: 'url(#mm-shadow)'
    }));
    // ── Logo image ────────────────────────────────────────────────
    const logoImg = $1afced4d205e7b8e$var$svgEl('image', {
        href: $1afced4d205e7b8e$var$LOGO_URL.href,
        x: $1afced4d205e7b8e$var$CX - 42,
        y: $1afced4d205e7b8e$var$CY - 50,
        width: '84',
        height: '84',
        preserveAspectRatio: 'xMidYMid meet',
        'clip-path': 'url(#mm-logo-clip)'
    });
    svg.appendChild(logoImg);
    // ── Motivational phrase ──────────────────────────────────────
    const phraseIdx = Math.floor(Date.now() / 30000) % (0, $deb185f198c84388$export$a4ca1752b438d9b6).length;
    const phraseEl = $1afced4d205e7b8e$var$svgEl('text', {
        id: 'mm-dial-phrase',
        x: $1afced4d205e7b8e$var$CX,
        y: $1afced4d205e7b8e$var$CY + 51,
        'text-anchor': 'middle',
        'dominant-baseline': 'central',
        fill: '#A07860',
        'font-family': "'Signika Negative', sans-serif",
        'font-size': '8.5',
        'font-style': 'italic'
    });
    phraseEl.textContent = (0, $deb185f198c84388$export$a4ca1752b438d9b6)[phraseIdx];
    svg.appendChild(phraseEl);
    return svg;
}
// ── Phrase rotation (every 8s) ────────────────────────────────
let $1afced4d205e7b8e$var$_phraseTimer = null;
function $1afced4d205e7b8e$export$7225a1d0fe661f18() {
    $1afced4d205e7b8e$export$7aa114ca23fb46d();
    let idx = Math.floor(Date.now() / 30000) % (0, $deb185f198c84388$export$a4ca1752b438d9b6).length;
    $1afced4d205e7b8e$var$_phraseTimer = setInterval(()=>{
        const el = document.getElementById('mm-dial-phrase');
        if (!el) return;
        idx = (idx + 1) % (0, $deb185f198c84388$export$a4ca1752b438d9b6).length;
        el.style.opacity = '0';
        setTimeout(()=>{
            el.textContent = (0, $deb185f198c84388$export$a4ca1752b438d9b6)[idx];
            el.style.opacity = '1';
        }, 350);
    }, 8000);
}
function $1afced4d205e7b8e$export$7aa114ca23fb46d() {
    if ($1afced4d205e7b8e$var$_phraseTimer !== null) {
        clearInterval($1afced4d205e7b8e$var$_phraseTimer);
        $1afced4d205e7b8e$var$_phraseTimer = null;
    }
}



// ============================================================
//  MASAMADREAM — PWA Install Prompt
//  Fase 4: captura beforeinstallprompt, muestra banner custom
// ============================================================
let $8d062fa4fd48e6be$var$_deferredPrompt = null;
function $8d062fa4fd48e6be$export$9f9b52cff878473a() {
    // Capture the browser's install event
    window.addEventListener('beforeinstallprompt', (e)=>{
        e.preventDefault();
        $8d062fa4fd48e6be$var$_deferredPrompt = e;
        // Only show banner if not already installed
        if (!$8d062fa4fd48e6be$var$isInstalled()) $8d062fa4fd48e6be$var$_showBanner();
    });
    // Hide banner once installed
    window.addEventListener('appinstalled', ()=>{
        $8d062fa4fd48e6be$var$_hideBanner();
        $8d062fa4fd48e6be$var$_deferredPrompt = null;
    });
    // Wire buttons
    document.getElementById('mm-install-btn')?.addEventListener('click', async ()=>{
        if (!$8d062fa4fd48e6be$var$_deferredPrompt) return;
        $8d062fa4fd48e6be$var$_deferredPrompt.prompt();
        const { outcome: outcome } = await $8d062fa4fd48e6be$var$_deferredPrompt.userChoice;
        if (outcome === 'accepted') $8d062fa4fd48e6be$var$_hideBanner();
        $8d062fa4fd48e6be$var$_deferredPrompt = null;
    });
    document.getElementById('mm-install-dismiss')?.addEventListener('click', ()=>{
        $8d062fa4fd48e6be$var$_hideBanner();
        // Remember dismissal for this session
        sessionStorage.setItem('mm_install_dismissed', '1');
    });
}
function $8d062fa4fd48e6be$var$_showBanner() {
    if (sessionStorage.getItem('mm_install_dismissed')) return;
    const banner = document.getElementById('mm-install-banner');
    if (banner) {
        banner.classList.remove('mm-hidden');
        requestAnimationFrame(()=>banner.classList.add('is-visible'));
    }
}
function $8d062fa4fd48e6be$var$_hideBanner() {
    const banner = document.getElementById('mm-install-banner');
    if (!banner) return;
    banner.classList.remove('is-visible');
    banner.addEventListener('transitionend', ()=>{
        banner.classList.add('mm-hidden');
    }, {
        once: true
    });
}
function $8d062fa4fd48e6be$var$isInstalled() {
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
}


// ============================================================
//  MASAMADREAM — History Screen
//  Fase 4: lista de procesos archivados con rating
// ============================================================

const $2885610f92731c27$var$DATE_FMT = {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
};
function $2885610f92731c27$export$bd7971081512ad68(store) {
    const container = document.getElementById('mm-history-list');
    if (!container) return;
    const { history: history } = store.load();
    container.innerHTML = '';
    if (!history || history.length === 0) {
        container.innerHTML = `
      <div class="mm-empty-state">
        <span class="mm-empty-state-icon">\u{1F4D6}</span>
        <span class="mm-empty-state-text">Todav\xeda no has completado ning\xfan proceso.</span>
      </div>`;
        return;
    }
    // Newest first
    [
        ...history
    ].reverse().forEach((proc, idx)=>{
        const pData = (0, $deb185f198c84388$export$ffa50ca9b2a96ffa)[proc.type];
        const emoji = pData?.emoji || "\uD83C\uDF5E";
        const label = pData?.label || proc.type.toUpperCase();
        const totalDays = pData?.totalDays || '?';
        const startDate = new Date(proc.startDate).toLocaleDateString('es-CR', $2885610f92731c27$var$DATE_FMT);
        const endDate = proc.endDate ? new Date(proc.endDate).toLocaleDateString('es-CR', $2885610f92731c27$var$DATE_FMT) : "\u2014";
        const daysCompleted = proc.completedIds?.length || 0;
        const totalActs = pData?.activities?.length || 1;
        const pct = Math.round(daysCompleted / totalActs * 100);
        const outcomeLabel = {
            completed: "\u2705 Completado",
            abandoned: "\uD83D\uDEAB Abandonado"
        }[proc.outcome] || "\uD83D\uDCC1 Archivado";
        const outcomeClass = proc.outcome === 'completed' ? 'is-success' : 'is-abandoned';
        // Stars
        const starsHtml = [
            1,
            2,
            3,
            4,
            5
        ].map((n)=>`<span class="mm-hist-star ${n <= (proc.rating || 0) ? 'is-filled' : ''}">\u{2605}</span>`).join('');
        const card = document.createElement('div');
        card.className = 'mm-hist-card';
        card.setAttribute('role', 'listitem');
        card.innerHTML = `
      <div class="mm-hist-card-header">
        <span class="mm-hist-emoji" aria-hidden="true">${emoji}</span>
        <div class="mm-hist-info">
          <div class="mm-hist-label">${label}</div>
          <div class="mm-hist-dates">${startDate} \u{2192} ${endDate}</div>
        </div>
        <span class="mm-hist-outcome ${outcomeClass}">${outcomeLabel}</span>
      </div>

      <div class="mm-hist-bar-wrap">
        <div class="mm-hist-bar">
          <div class="mm-hist-bar-fill ${outcomeClass}" style="width:${pct}%"></div>
        </div>
        <span class="mm-hist-pct">${daysCompleted}/${totalActs} actividades</span>
      </div>

      ${proc.rating ? `
        <div class="mm-hist-rating">
          ${starsHtml}
        </div>` : ''}
    `;
        container.appendChild(card);
    });
    // Summary stats
    const completed = history.filter((p)=>p.outcome === 'completed').length;
    const statsEl = document.getElementById('mm-history-stats');
    if (statsEl) statsEl.innerHTML = `
      <span class="mm-hist-stat"><strong>${history.length}</strong> procesos</span>
      <span class="mm-hist-sep">\xb7</span>
      <span class="mm-hist-stat"><strong>${completed}</strong> completados</span>
    `;
}


// ============================================================
//  MASAMADREAM — Onboarding (primera visita)
//  Fase 5: 3 slides, se muestra solo la primera vez
// ============================================================
const $c78a0a909159f8c9$var$KEY = 'mm_onboarded';
const $c78a0a909159f8c9$var$SLIDES = [
    {
        emoji: "\uD83C\uDF31",
        title: "\xa1Tu masa madre te necesita!",
        desc: "MASAGOTCHI te gu\xeda paso a paso en el proceso de fermentaci\xf3n y preparaci\xf3n del pan artesanal."
    },
    {
        emoji: "\uD83D\uDCCB",
        title: 'Actividades diarias',
        desc: "Cada d\xeda tiene sus tareas. Toca cualquier actividad para ver las instrucciones detalladas y m\xe1rcalas al completar."
    },
    {
        emoji: "\uD83D\uDD14",
        title: "Nunca te pierdas una alimentaci\xf3n",
        desc: "Activa las notificaciones y te avisaremos exactamente cu\xe1ndo actuar para que tu masa salga perfecta."
    }
];
function $c78a0a909159f8c9$export$b4a052585a40e549() {
    return !localStorage.getItem($c78a0a909159f8c9$var$KEY);
}
function $c78a0a909159f8c9$export$85893baa6f8c086f() {
    localStorage.setItem($c78a0a909159f8c9$var$KEY, '1');
}
function $c78a0a909159f8c9$export$4148de1789ae76e2(onFinish) {
    const screen = document.getElementById('mm-screen-onboarding');
    if (!screen) {
        onFinish();
        return;
    }
    let current = 0;
    const slideContainer = screen.querySelector('.mm-ob-slides');
    const dots = screen.querySelectorAll('.mm-ob-dot');
    const btnNext = screen.querySelector('#mm-ob-next');
    const btnSkip = screen.querySelector('#mm-ob-skip');
    function goTo(idx) {
        current = idx;
        // Update slides
        screen.querySelectorAll('.mm-ob-slide').forEach((s, i)=>{
            s.classList.toggle('is-active', i === idx);
        });
        // Update dots
        dots.forEach((d, i)=>d.classList.toggle('is-active', i === idx));
        // Update button label
        const isLast = idx === $c78a0a909159f8c9$var$SLIDES.length - 1;
        btnNext.textContent = isLast ? "\xa1Empezar! \uD83C\uDF5E" : "Siguiente \u2192";
    }
    function finish() {
        $c78a0a909159f8c9$export$85893baa6f8c086f();
        screen.classList.remove('is-active');
        onFinish();
    }
    btnNext.addEventListener('click', ()=>{
        if (current < $c78a0a909159f8c9$var$SLIDES.length - 1) goTo(current + 1);
        else finish();
    });
    btnSkip.addEventListener('click', finish);
    // Touch swipe support
    let _sx = 0;
    slideContainer?.addEventListener('touchstart', (e)=>{
        _sx = e.touches[0].clientX;
    }, {
        passive: true
    });
    slideContainer?.addEventListener('touchend', (e)=>{
        const dx = e.changedTouches[0].clientX - _sx;
        if (dx < -40 && current < $c78a0a909159f8c9$var$SLIDES.length - 1) goTo(current + 1);
        if (dx > 40 && current > 0) goTo(current - 1);
    }, {
        passive: true
    });
    goTo(0);
}


// ============================================================
//  MASAMADREAM — Mascot Mood System
//  Fase 5: cambia emoji + mensaje según estado del proceso
// ============================================================

// Moods: emoji overlay + status text + pulse class
const $3b3df872ab3ba4a3$var$MOODS = {
    happy: {
        overlay: "\uD83D\uDE0A",
        status: "\xa1Todo va bien! \uD83C\uDF31",
        pulse: 'mm-mood--happy'
    },
    behind: {
        overlay: "\uD83D\uDE34",
        status: 'Tu masa te espera...',
        pulse: 'mm-mood--behind'
    },
    overdue: {
        overlay: "\uD83D\uDE30",
        status: "\xa1Actividad pendiente ahora!",
        pulse: 'mm-mood--overdue'
    },
    complete: {
        overlay: "\uD83E\uDD73",
        status: "\xa1D\xeda completado! \uD83C\uDF89",
        pulse: 'mm-mood--complete'
    },
    done: {
        overlay: "\uD83C\uDFC6",
        status: "\xa1Proceso completo! \xa1Eres un panadero! \uD83C\uDF5E",
        pulse: 'mm-mood--done'
    },
    idle: {
        overlay: "\uD83D\uDE0C",
        status: "Listo para empezar \u2728",
        pulse: 'mm-mood--idle'
    }
};
function $3b3df872ab3ba4a3$export$ba57c26732c8d191(process, store) {
    if (!process) return $3b3df872ab3ba4a3$var$MOODS.idle;
    const pData = (0, $deb185f198c84388$export$ffa50ca9b2a96ffa)[process.type];
    const now = Date.now();
    const start = new Date(process.startDate).getTime();
    const totalActs = pData?.activities?.length || 1;
    const completed = process.completedIds?.length || 0;
    // All done?
    if (completed >= totalActs) return $3b3df872ab3ba4a3$var$MOODS.done;
    // Today's activities
    const todayActs = (pData?.activities || []).filter((a)=>a.day === process.currentDay);
    const todayDone = todayActs.every((a)=>store.isCompleted(a.id));
    if (todayDone && todayActs.length > 0) return $3b3df872ab3ba4a3$var$MOODS.complete;
    // Any overdue incomplete activity?
    const overdue = (pData?.activities || []).some((a)=>{
        const scheduled = start + a.timeOffset * 3600000;
        return scheduled < now && !store.isCompleted(a.id);
    });
    if (overdue) {
        // How overdue? > 2h = behind, just now = overdue
        const mostOverdue = (pData?.activities || []).filter((a)=>!store.isCompleted(a.id)).map((a)=>({
                ...a,
                scheduledAt: start + a.timeOffset * 3600000
            })).filter((a)=>a.scheduledAt < now).sort((a, b)=>a.scheduledAt - b.scheduledAt)[0];
        const overdueMs = mostOverdue ? now - mostOverdue.scheduledAt : 0;
        return overdueMs > 7200000 ? $3b3df872ab3ba4a3$var$MOODS.behind : $3b3df872ab3ba4a3$var$MOODS.overdue;
    }
    return $3b3df872ab3ba4a3$var$MOODS.happy;
}
function $3b3df872ab3ba4a3$export$7dfd3070945fbbeb(mood) {
    // Update overlay emoji on dial center and home mascot
    const overlay = document.getElementById('mm-mascot-mood-overlay');
    if (overlay) {
        overlay.textContent = mood.overlay;
        overlay.classList.remove(...Object.values($3b3df872ab3ba4a3$var$MOODS).map((m)=>m.pulse));
        overlay.classList.add(mood.pulse);
    }
    // Update status text
    const statusEl = document.getElementById('mm-mascot-status');
    if (statusEl) statusEl.textContent = mood.status;
}
function $3b3df872ab3ba4a3$export$69206e5c81577173(process, store) {
    const mood = $3b3df872ab3ba4a3$export$ba57c26732c8d191(process, store);
    $3b3df872ab3ba4a3$export$7dfd3070945fbbeb(mood);
}


// ============================================================
//  MASAMADREAM — Achievements System
//  Fase 6: logros desbloqueables basados en historial
// ============================================================
const $2b661a9c6633cf96$export$832dd75819e4111d = {
    iniciado: {
        id: 'iniciado',
        emoji: "\uD83C\uDF3F",
        title: 'Iniciado',
        desc: 'Completaste tu primer proceso'
    },
    first_p1: {
        id: 'first_p1',
        emoji: "\uD83C\uDF31",
        title: 'Primer Cultivo',
        desc: "Completaste tu primera fermentaci\xf3n de 7 d\xedas"
    },
    first_p2: {
        id: 'first_p2',
        emoji: "\uD83C\uDF5E",
        title: 'Primera Hogaza',
        desc: "Completaste tu primer proceso de preparaci\xf3n de pan"
    },
    perseverante: {
        id: 'perseverante',
        emoji: "\uD83D\uDCAA",
        title: 'Perseverante',
        desc: 'Completaste 2 procesos en total'
    },
    maestro: {
        id: 'maestro',
        emoji: "\uD83C\uDFC6",
        title: 'Maestro de la Masa',
        desc: "Completaste tanto la fermentaci\xf3n como la preparaci\xf3n"
    },
    estrella: {
        id: 'estrella',
        emoji: "\u2B50",
        title: 'Panadero Estrella',
        desc: 'Calificaste un proceso con 5 estrellas'
    }
};
function $2b661a9c6633cf96$export$aa04039c1ab25601(store) {
    const state = store.load();
    const history = state.history || [];
    const completed = history.filter((p)=>p.outcome === 'completed');
    const newlyUnlocked = [];
    function tryUnlock(id) {
        if (store.unlockAchievement(id)) newlyUnlocked.push($2b661a9c6633cf96$export$832dd75819e4111d[id]);
    }
    // 🌿 Iniciado — first completed process
    if (completed.length >= 1) tryUnlock('iniciado');
    // 🌱 Primer Cultivo — first P1
    if (completed.some((p)=>p.type === 'p1')) tryUnlock('first_p1');
    // 🍞 Primera Hogaza — first P2
    if (completed.some((p)=>p.type === 'p2')) tryUnlock('first_p2');
    // 💪 Perseverante — 2+ completed
    if (completed.length >= 2) tryUnlock('perseverante');
    // 🏆 Maestro — completed both P1 and P2
    if (completed.some((p)=>p.type === 'p1') && completed.some((p)=>p.type === 'p2')) tryUnlock('maestro');
    // ⭐ Estrella — rated 5/5
    if (completed.some((p)=>p.rating === 5)) tryUnlock('estrella');
    return newlyUnlocked;
}


// ============================================================
//  MASAMADREAM — Settings Screen
//  Fase 6: nombre del starter, logros, borrar datos
// ============================================================


function $574bfbbdc0cbba4f$export$7a58c148b4d703a6(store, { onBack: onBack, onReset: onReset, onNameSaved: onNameSaved, onStartDateChanged: onStartDateChanged } = {}) {
    // ── Back button ────────────────────────────────────────────
    document.getElementById('mm-btn-back-from-settings')?.addEventListener('click', ()=>{
        onBack?.();
    });
    // ── Save name ──────────────────────────────────────────────
    document.getElementById('mm-settings-save-name')?.addEventListener('click', ()=>{
        const input = document.getElementById('mm-settings-starter-name');
        const name = (input?.value || '').trim().slice(0, 30);
        store.setStarterName(name);
        (0, $92c4faff7f0429a4$export$b410431fab84fa58)(`\u{1F331} Nombre guardado: ${name || 'Starter'}`);
        onNameSaved?.(name);
    });
    // ── Save start date ────────────────────────────────────────
    document.getElementById('mm-settings-save-start-date')?.addEventListener('click', ()=>{
        const input = document.getElementById('mm-settings-start-date');
        if (!input?.value) {
            (0, $92c4faff7f0429a4$export$b410431fab84fa58)("\u26A0\uFE0F Selecciona una fecha v\xe1lida");
            return;
        }
        // datetime-local gives local time — convert to ISO UTC
        const iso = new Date(input.value).toISOString();
        const processId = store.state.viewingId;
        const updated = store.setStartDate(iso, processId);
        if (!updated) {
            (0, $92c4faff7f0429a4$export$b410431fab84fa58)("\u26A0\uFE0F No hay proceso activo");
            return;
        }
        $574bfbbdc0cbba4f$var$_updateStartPreview(updated);
        (0, $92c4faff7f0429a4$export$b410431fab84fa58)(`\u{1F4C5} Ciclo actualizado \u{2014} D\xeda ${updated.currentDay}`);
        onStartDateChanged?.(updated);
    });
    // Live preview when user changes the input
    document.getElementById('mm-settings-start-date')?.addEventListener('change', ()=>{
        const input = document.getElementById('mm-settings-start-date');
        const preview = document.getElementById('mm-settings-start-preview');
        if (!input?.value || !preview) return;
        const dt = new Date(input.value);
        const process = store.getViewingProcess();
        if (!process) return;
        const maxDays = process.type === 'p1' ? 7 : 5;
        const diffMs = Date.now() - dt.getTime();
        const day = Math.min(Math.max(Math.floor(diffMs / 86400000) + 1, 1), maxDays);
        preview.textContent = `\u{2192} D\xeda ${day} de ${maxDays}`;
    });
    // ── Clear all data ─────────────────────────────────────────
    document.getElementById('mm-settings-clear-data')?.addEventListener('click', ()=>{
        if (!confirm("\xbfBorrar TODOS los datos? Esto eliminar\xe1 tu proceso activo, historial y logros. Esta acci\xf3n no se puede deshacer.")) return;
        store.clearAll();
        (0, $92c4faff7f0429a4$export$b410431fab84fa58)("\uD83D\uDDD1 Datos eliminados");
        onReset?.();
    });
}
function $574bfbbdc0cbba4f$export$b14c3951ea30493a(store) {
    const state = store.load();
    const viewingProcess = store.getViewingProcess();
    // Starter name input
    const nameInput = document.getElementById('mm-settings-starter-name');
    if (nameInput) nameInput.value = state.starterName || '';
    // Cycle start date section — only visible when a process is active
    const cycleSection = document.getElementById('mm-settings-cycle-section');
    if (cycleSection) {
        if (viewingProcess) {
            cycleSection.style.display = '';
            const dtInput = document.getElementById('mm-settings-start-date');
            if (dtInput) dtInput.value = $574bfbbdc0cbba4f$var$_isoToLocalInput(viewingProcess.startDate);
            $574bfbbdc0cbba4f$var$_updateStartPreview(viewingProcess);
        } else cycleSection.style.display = 'none';
    }
    // Achievements
    $574bfbbdc0cbba4f$var$_renderAchievementBadges(store);
}
// ── Private ───────────────────────────────────────────────────
/** Convert ISO string to the value format required by <input type="datetime-local"> (local time, no seconds) */ function $574bfbbdc0cbba4f$var$_isoToLocalInput(iso) {
    if (!iso) return '';
    const d = new Date(iso);
    const pad = (n)=>String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
/** Update the "→ Día X de Y" preview text below the date input */ function $574bfbbdc0cbba4f$var$_updateStartPreview(process) {
    const preview = document.getElementById('mm-settings-start-preview');
    if (!preview || !process) return;
    const maxDays = process.type === 'p1' ? 7 : 5;
    preview.textContent = `\u{2192} D\xeda ${process.currentDay} de ${maxDays}`;
}
function $574bfbbdc0cbba4f$var$_renderAchievementBadges(store) {
    const container = document.getElementById('mm-settings-achievements');
    if (!container) return;
    const state = store.load();
    const unlocked = state.achievements || [];
    container.innerHTML = '';
    if (unlocked.length === 0) {
        container.innerHTML = `
      <div class="mm-empty-state">
        <span class="mm-empty-state-icon">\u{1F512}</span>
        <span class="mm-empty-state-text">Todav\xeda no has desbloqueado ning\xfan logro. \xa1Completa tu primer proceso!</span>
      </div>`;
        return;
    }
    unlocked.forEach((id)=>{
        const badge = (0, $2b661a9c6633cf96$export$832dd75819e4111d)[id];
        if (!badge) return;
        const el = document.createElement('div');
        el.className = 'mm-achievement-badge';
        el.innerHTML = `
      <span class="mm-achievement-emoji" aria-hidden="true">${badge.emoji}</span>
      <div class="mm-achievement-text">
        <div class="mm-achievement-title">${badge.title}</div>
        <div class="mm-achievement-desc">${badge.desc}</div>
      </div>`;
        container.appendChild(el);
    });
    // Show locked badges (greyed out) so users know what to aim for
    const all = Object.values((0, $2b661a9c6633cf96$export$832dd75819e4111d));
    const locked = all.filter((b)=>!unlocked.includes(b.id));
    if (locked.length) {
        const sep = document.createElement('p');
        sep.className = 'mm-settings-locked-label';
        sep.textContent = 'Por desbloquear:';
        container.appendChild(sep);
        locked.forEach((badge)=>{
            const el = document.createElement('div');
            el.className = 'mm-achievement-badge is-locked';
            el.innerHTML = `
        <span class="mm-achievement-emoji" aria-hidden="true">\u{1F512}</span>
        <div class="mm-achievement-text">
          <div class="mm-achievement-title">${badge.title}</div>
          <div class="mm-achievement-desc">${badge.desc}</div>
        </div>`;
            container.appendChild(el);
        });
    }
}


var $f3d345ebd68f199e$exports = {};
$f3d345ebd68f199e$exports = $parcel$resolve("f6ezO");


// ─── Service Worker ────────────────────────────────────────
if ('serviceWorker' in navigator) window.addEventListener('load', ()=>{
    navigator.serviceWorker.register($f3d345ebd68f199e$exports).then(()=>console.log("[MM] SW registered \u2713")).catch((err)=>console.warn('[MM] SW failed:', err));
});
// ─── Boot ──────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', ()=>{
    $ce77af30fc9a6e63$var$initApp();
});
let $ce77af30fc9a6e63$var$_store = null;
function $ce77af30fc9a6e63$var$initApp() {
    $ce77af30fc9a6e63$var$_store = new (0, $3fa2584d11fbd999$export$390f32400eaf98c9)();
    (0, $260696580986d9c4$export$e2528e2f8783b5e2)();
    (0, $8d062fa4fd48e6be$export$9f9b52cff878473a)();
    (0, $574bfbbdc0cbba4f$export$7a58c148b4d703a6)($ce77af30fc9a6e63$var$_store, {
        onBack: ()=>{
            const state = $ce77af30fc9a6e63$var$_store.load();
            if (state.processes?.length) (0, $2faff07f6008cb7d$export$c71b571bc504786c)('dashboard');
            else {
                (0, $2faff07f6008cb7d$export$c71b571bc504786c)('home');
                $ce77af30fc9a6e63$var$updateGreeting($ce77af30fc9a6e63$var$_store);
            }
        },
        onReset: ()=>{
            (0, $2faff07f6008cb7d$export$c71b571bc504786c)('onboarding');
            (0, $c78a0a909159f8c9$export$4148de1789ae76e2)(()=>$ce77af30fc9a6e63$var$_bootHome($ce77af30fc9a6e63$var$_store));
        },
        onNameSaved: ()=>$ce77af30fc9a6e63$var$updateGreeting($ce77af30fc9a6e63$var$_store),
        onStartDateChanged: ()=>{
            const updated = $ce77af30fc9a6e63$var$_store.load();
            const viewing = $ce77af30fc9a6e63$var$_store.getViewingProcess();
            if (viewing) {
                (0, $de59b905778ac270$export$9caf03b53d8b893a)();
                (0, $1afced4d205e7b8e$export$7aa114ca23fb46d)();
                $ce77af30fc9a6e63$var$openDashboard(viewing, $ce77af30fc9a6e63$var$_store);
            }
        }
    });
    $ce77af30fc9a6e63$var$wireSettingsButton($ce77af30fc9a6e63$var$_store);
    $ce77af30fc9a6e63$var$wireHomeButtons($ce77af30fc9a6e63$var$_store);
    $ce77af30fc9a6e63$var$wireDashboardButtons($ce77af30fc9a6e63$var$_store);
    $ce77af30fc9a6e63$var$wireHistoryScreen($ce77af30fc9a6e63$var$_store);
    $ce77af30fc9a6e63$var$wireAbandonButton($ce77af30fc9a6e63$var$_store);
    // Restore scheduled notifications from storage
    (0, $1eab08be386b9a1b$export$45477eed36a452d4)();
    if ((0, $c78a0a909159f8c9$export$b4a052585a40e549)()) {
        // Show onboarding first, then home
        (0, $2faff07f6008cb7d$export$c71b571bc504786c)('onboarding');
        (0, $c78a0a909159f8c9$export$4148de1789ae76e2)(()=>{
            $ce77af30fc9a6e63$var$_bootHome($ce77af30fc9a6e63$var$_store);
        });
    } else $ce77af30fc9a6e63$var$_bootHome($ce77af30fc9a6e63$var$_store);
    requestAnimationFrame(()=>{
        document.getElementById('mm-loading')?.classList.add('is-hidden');
    });
}
function $ce77af30fc9a6e63$var$_bootHome(store) {
    const state = store.load();
    $ce77af30fc9a6e63$var$updateGreeting(store);
    (0, $2faff07f6008cb7d$export$c71b571bc504786c)('home');
    $ce77af30fc9a6e63$var$renderActiveProcessList(store);
    const firstProc = state.processes?.[0] ?? null;
    (0, $3b3df872ab3ba4a3$export$69206e5c81577173)(firstProc, store);
    if (state.history?.length) document.getElementById('mm-btn-view-history')?.classList.remove('mm-hidden');
}
// ─── Greeting ──────────────────────────────────────────────
function $ce77af30fc9a6e63$var$updateGreeting(store) {
    const name = store.getStarterName();
    const el = document.getElementById('mm-home-greeting-name');
    if (el) el.textContent = name || 'Panadero';
}
// ─── Settings button ───────────────────────────────────────
function $ce77af30fc9a6e63$var$wireSettingsButton(store) {
    document.getElementById('mm-header-settings-btn')?.addEventListener('click', ()=>{
        (0, $574bfbbdc0cbba4f$export$b14c3951ea30493a)(store);
        (0, $2faff07f6008cb7d$export$c71b571bc504786c)('settings');
    });
}
// ─── Home buttons ──────────────────────────────────────────
function $ce77af30fc9a6e63$var$wireHomeButtons(store) {
    [
        'p1',
        'p2',
        'p3'
    ].forEach((type)=>{
        document.getElementById(`mm-btn-start-${type}`)?.addEventListener('click', ()=>{
            const proc = store.startProcess(type);
            $ce77af30fc9a6e63$var$requestNotificationPermission().then(()=>(0, $1eab08be386b9a1b$export$eac83ef81709efc5)(proc));
            $ce77af30fc9a6e63$var$openDashboard(proc.id, store);
            (0, $92c4faff7f0429a4$export$b410431fab84fa58)("\u2705 \xa1Proceso iniciado!");
        });
    });
    document.getElementById('mm-btn-view-history')?.addEventListener('click', ()=>{
        (0, $2885610f92731c27$export$bd7971081512ad68)(store);
        (0, $2faff07f6008cb7d$export$c71b571bc504786c)('history');
    });
}
// ─── Dashboard buttons ─────────────────────────────────────
function $ce77af30fc9a6e63$var$wireDashboardButtons(store) {
    document.getElementById('mm-btn-back-home')?.addEventListener('click', ()=>{
        (0, $de59b905778ac270$export$9caf03b53d8b893a)();
        (0, $1afced4d205e7b8e$export$7aa114ca23fb46d)();
        document.getElementById('mm-active-badge')?.classList.add('mm-hidden');
        $ce77af30fc9a6e63$var$backToHome(store);
    });
    document.getElementById('mm-btn-complete-process')?.addEventListener('click', ()=>{
        if (!confirm("\xbfMarcar el proceso como completado?")) return;
        $ce77af30fc9a6e63$var$finishProcess(store, 'completed');
    });
}
function $ce77af30fc9a6e63$var$wireAbandonButton(store) {
    document.getElementById('mm-btn-abandon')?.addEventListener('click', ()=>{
        if (!confirm("\xbfAbandonar el proceso actual? Se guardar\xe1 en tu historial.")) return;
        $ce77af30fc9a6e63$var$finishProcess(store, 'abandoned');
        (0, $92c4faff7f0429a4$export$b410431fab84fa58)("\uD83D\uDEAB Proceso abandonado y archivado");
    });
}
// ─── Open dashboard ────────────────────────────────────────
function $ce77af30fc9a6e63$var$openDashboard(processId, store) {
    store.setViewingId(processId);
    const process = store.getProcess(processId);
    (0, $2faff07f6008cb7d$export$c71b571bc504786c)('dashboard');
    $ce77af30fc9a6e63$var$updateActiveBadge(process);
    $ce77af30fc9a6e63$var$injectDial(process);
    (0, $3b3df872ab3ba4a3$export$69206e5c81577173)(process, store);
    (0, $ef4d3d31fc602be9$export$574469e75e19ecfe)(process, store, (dayNum, totalDays)=>{
        $ce77af30fc9a6e63$var$onDayComplete(dayNum, totalDays, processId, store);
    });
    (0, $1eab08be386b9a1b$export$c677a7e6b63195e2)(process);
    (0, $de59b905778ac270$export$1ad018ea9ed1d4c7)(process, store);
    (0, $1afced4d205e7b8e$export$7225a1d0fe661f18)();
}
// ─── Day complete ──────────────────────────────────────────
function $ce77af30fc9a6e63$var$onDayComplete(dayNum, totalDays, processId, store) {
    if (dayNum === totalDays) {
        (0, $92c4faff7f0429a4$export$b410431fab84fa58)("\uD83C\uDF89 \xa1\xdaltimo d\xeda completado! \xa1Incre\xedble trabajo!");
        setTimeout(()=>$ce77af30fc9a6e63$var$showCompletionScreen(store), 1800);
    } else {
        (0, $92c4faff7f0429a4$export$b410431fab84fa58)(`\u{2705} \xa1D\xeda ${dayNum} completado! Ma\xf1ana: D\xeda ${dayNum + 1} \u{1F331}`);
        const proc = store.getProcess(processId);
        if (proc) {
            store.load(); // refresh currentDay
            $ce77af30fc9a6e63$var$injectDial(proc);
            $ce77af30fc9a6e63$var$updateActiveBadge(proc);
            (0, $3b3df872ab3ba4a3$export$69206e5c81577173)(proc, store);
        }
    }
}
// ─── Completion screen ─────────────────────────────────────
function $ce77af30fc9a6e63$var$showCompletionScreen(store) {
    (0, $de59b905778ac270$export$9caf03b53d8b893a)();
    (0, $1afced4d205e7b8e$export$7aa114ca23fb46d)();
    const proc = store.getViewingProcess();
    const type = proc?.type || 'p1';
    const procId = proc?.id;
    document.querySelectorAll('.mm-screen').forEach((s)=>s.classList.remove('is-active'));
    const screen = document.getElementById('mm-screen-completion');
    if (screen) screen.classList.add('is-active');
    // Web Share button
    const shareBtn = document.getElementById('mm-btn-share');
    if (shareBtn) {
        shareBtn.classList.remove('mm-hidden');
        shareBtn.onclick = ()=>$ce77af30fc9a6e63$var$shareCompletion(type);
    }
    // Rating stars — re-wire each time (clone to remove old listeners)
    screen?.querySelectorAll('.mm-star').forEach((star, i)=>{
        const fresh = star.cloneNode(true);
        star.replaceWith(fresh);
        fresh.addEventListener('click', ()=>{
            screen.querySelectorAll('.mm-star').forEach((s, j)=>{
                s.classList.toggle('is-active', j <= i);
            });
            if (procId) store.archiveProcess(procId, 'completed', i + 1);
            $ce77af30fc9a6e63$var$_notifyNewAchievements(store);
            (0, $92c4faff7f0429a4$export$b410431fab84fa58)("\u2B50 \xa1Gracias por tu valoraci\xf3n!");
            setTimeout(()=>$ce77af30fc9a6e63$var$backToHome(store), 1200);
        });
    });
    const skipBtn = screen?.querySelector('#mm-btn-skip-rating');
    if (skipBtn) {
        const fresh = skipBtn.cloneNode(true);
        skipBtn.replaceWith(fresh);
        fresh.addEventListener('click', ()=>{
            if (procId) store.archiveProcess(procId, 'completed', null);
            $ce77af30fc9a6e63$var$_notifyNewAchievements(store);
            $ce77af30fc9a6e63$var$backToHome(store);
        });
    }
}
function $ce77af30fc9a6e63$var$finishProcess(store, outcome) {
    (0, $de59b905778ac270$export$9caf03b53d8b893a)();
    (0, $1afced4d205e7b8e$export$7aa114ca23fb46d)();
    const procId = store.state.viewingId;
    if (procId) {
        (0, $1eab08be386b9a1b$export$6957c77dcbb1ab7e)(procId);
        store.archiveProcess(procId, outcome);
    }
    $ce77af30fc9a6e63$var$backToHome(store);
}
function $ce77af30fc9a6e63$var$backToHome(store) {
    const state = store.load();
    (0, $2faff07f6008cb7d$export$c71b571bc504786c)('home');
    document.getElementById('mm-active-badge')?.classList.add('mm-hidden');
    $ce77af30fc9a6e63$var$renderActiveProcessList(store);
    const firstProc = state.processes?.[0] ?? null;
    (0, $3b3df872ab3ba4a3$export$69206e5c81577173)(firstProc, store);
    if (state.history?.length) document.getElementById('mm-btn-view-history')?.classList.remove('mm-hidden');
}
// ─── Active processes list ──────────────────────────────────
function $ce77af30fc9a6e63$var$renderActiveProcessList(store) {
    const processes = store.getActiveProcesses();
    const container = document.getElementById('mm-processes-list');
    if (!container) return;
    if (!processes.length) {
        container.classList.add('mm-hidden');
        container.innerHTML = '';
        return;
    }
    container.classList.remove('mm-hidden');
    container.innerHTML = processes.map((proc)=>{
        const total = (0, $deb185f198c84388$export$ffa50ca9b2a96ffa)[proc.type]?.totalDays ?? 7;
        const pct = Math.round((proc.currentDay - 1) / total * 100);
        return `
      <div class="mm-process-item">
        <span class="mm-process-emoji" aria-hidden="true">${proc.type === 'p1' ? "\uD83C\uDF31" : proc.type === 'p2' ? "\uD83C\uDF5E" : "\uD83C\uDF55"}</span>
        <div class="mm-process-info">
          <div class="mm-process-label">${proc.label}</div>
          <div class="mm-process-day">D\xeda ${proc.currentDay} de ${total}</div>
          <div class="mm-process-bar"><div class="mm-process-bar-fill" style="width:${pct}%"></div></div>
        </div>
        <button class="mm-btn mm-btn--outline mm-btn--sm" data-proc-id="${proc.id}">Continuar \u{2192}</button>
      </div>
    `;
    }).join('');
    container.querySelectorAll('.mm-process-item button').forEach((btn)=>{
        btn.addEventListener('click', ()=>{
            const id = btn.dataset.procId;
            $ce77af30fc9a6e63$var$openDashboard(id, store);
        });
    });
}
// ─── Share ─────────────────────────────────────────────────
async function $ce77af30fc9a6e63$var$shareCompletion(type) {
    const shareTexts = {
        p1: "\xa1Complet\xe9 mi fermentaci\xf3n de masa madre en 7 d\xedas con MASAGOTCHI! \uD83C\uDF31\uD83C\uDF5E \xa1Mi cultivo est\xe1 vivo!",
        p2: "\xa1Acabo de hornear mi pan de masa madre artesanal con MASAGOTCHI! \uD83C\uDF5E\u2728 \xa1Huele incre\xedble!",
        p3: "\xa1Acabo de hacer mi pizza de masa madre con MASAGOTCHI! \uD83C\uDF55\u2728 \xa1Borde aireado y base crujiente!"
    };
    const text = shareTexts[type] ?? shareTexts['p2'];
    if (navigator.share) try {
        await navigator.share({
            title: "MASAGOTCHI \uD83C\uDF5E",
            text: text,
            url: window.location.href
        });
    } catch (_) {}
    else if (navigator.clipboard) {
        await navigator.clipboard.writeText(text);
        (0, $92c4faff7f0429a4$export$b410431fab84fa58)("\uD83D\uDCCB \xa1Copiado! Comp\xe1rtelo donde quieras");
    }
}
// ─── SVG Dial ──────────────────────────────────────────────
function $ce77af30fc9a6e63$var$injectDial(process) {
    const wrapper = document.getElementById('mm-dial-wrapper');
    if (!wrapper) return;
    wrapper.innerHTML = '';
    wrapper.appendChild((0, $1afced4d205e7b8e$export$13e1610f74a4e03)(process));
}
// ─── Header badge ──────────────────────────────────────────
function $ce77af30fc9a6e63$var$updateActiveBadge(process) {
    const badge = document.getElementById('mm-active-badge');
    const label = document.getElementById('mm-active-badge-label');
    if (!badge || !label) return;
    const total = (0, $deb185f198c84388$export$ffa50ca9b2a96ffa)[process.type]?.totalDays ?? 7;
    label.textContent = `${process.label} \xb7 D\xeda ${process.currentDay}/${total}`;
    badge.classList.remove('mm-hidden');
}
// ─── History screen ────────────────────────────────────────
function $ce77af30fc9a6e63$var$wireHistoryScreen(store) {
    document.getElementById('mm-btn-back-from-history')?.addEventListener('click', ()=>{
        (0, $2faff07f6008cb7d$export$c71b571bc504786c)('home');
        $ce77af30fc9a6e63$var$renderActiveProcessList(store);
    });
    document.getElementById('mm-btn-history-new-process')?.addEventListener('click', ()=>{
        (0, $2faff07f6008cb7d$export$c71b571bc504786c)('home');
        $ce77af30fc9a6e63$var$renderActiveProcessList(store);
    });
}
// ─── Achievements ──────────────────────────────────────────
function $ce77af30fc9a6e63$var$_notifyNewAchievements(store) {
    const newBadges = (0, $2b661a9c6633cf96$export$aa04039c1ab25601)(store);
    newBadges.forEach((badge, i)=>{
        setTimeout(()=>{
            (0, $92c4faff7f0429a4$export$b410431fab84fa58)(`${badge.emoji} \xa1Logro desbloqueado! "${badge.title}"`);
        }, i * 1800);
    });
}
// ─── Notification permission ────────────────────────────────
async function $ce77af30fc9a6e63$var$requestNotificationPermission() {
    if (!('Notification' in window)) return;
    if (Notification.permission === 'granted') return;
    if (Notification.permission === 'denied') return;
    try {
        const r = await Notification.requestPermission();
        if (r === 'granted') (0, $92c4faff7f0429a4$export$b410431fab84fa58)("\uD83D\uDD14 Notificaciones activadas");
    } catch (_) {}
}


//# sourceMappingURL=masagotchi.63b272cb.js.map
